//Ms clarity 1

if (window.__customJsLoaded) {
  // custom.js already loaded — kuch nahi karna, bas skip
} else {
  window.__customJsLoaded = true;


  // Ms clarity JavaScript errors error invoking enabledidusertypeonkeyboardlogging: java object is gone && JavaScript errors:undefined is not an object (evaluating 'r.addeventlistener')


  // =========================================================================
  // 1. COMBINED CRASH GUARD FOR ANDROID WEBVIEW & THIRD-PARTY MINIFIED ERRORS  
  // =========================================================================
  window.addEventListener('error', function(e) {
    if (e.message) {
      var msg = e.message.toLowerCase();
      if (
        msg.includes('enabledidusertypeonkeyboardlogging') || 
        msg.includes('postmessage: java object is gone') ||
        msg.includes('addeventlistener')
      ) {
        e.preventDefault();
        e.stopPropagation();
        return true; 
      }
    }
  }, true);

  window.onerror = function(message, url, line, col, error) {
    if (message) {
      var msg = message.toString().toLowerCase();
      if (
        msg.includes('enabledidusertypeonkeyboardlogging') || 
        msg.includes('postmessage: java object is gone') ||
        msg.includes('addeventlistener')
      ) {
        return true; 
      }
    }
  };
  // =========================================================================

// =========================================================================
// GOOGLE POSTMESSAGE ERROR SILENCER
// =========================================================================
(function() {
  var originalConsoleError = console.error;
  console.error = function(message) {
    if (message && typeof message === 'string') {
      // Agar error me postMessage aur google.com dono ho, toh use hide kar do
      if (message.includes('postMessage') && message.includes('google.com')) {
        return; 
      }
    }
    // Baaki saare real errors ko pehle ki tarah console me dikhne do
    originalConsoleError.apply(console, arguments);
  };
})();

       
$(document).ready(function(){

  // setTimeout(function(){
  // $('.recurpay__onetime_radio').trigger('click');
  // },3000)


(function() {
  const observer = new MutationObserver(() => {
    const recurpayWidget = document.querySelector(".recurpay-pdp-widget");
    if (!recurpayWidget) return;


    const twoTimePurchase = recurpayWidget.querySelector(
      '.recurpay__widget_container[data-type="subscription-purchase"]'
    );

    if (!twoTimePurchase) return;
    if (twoTimePurchase.classList.contains("auto-triggered")) return;

    // console.log("Triggering two-time purchase automatically...");
    twoTimePurchase.click();
    twoTimePurchase.classList.add("auto-triggered");

    // Hide offer applied div
    const offerAppliedDiv = document.querySelector(".offer-applied-div");
    if (offerAppliedDiv) offerAppliedDiv.style.display = "none";

    // Clone additional offer info only once
    const additionalOfferDiv = document.querySelector(".offer-applied-div");
    const hiddenLiquidDiv = document.querySelector(".additional_offer_information");
    if (additionalOfferDiv && hiddenLiquidDiv && !additionalOfferDiv.parentNode.querySelector(".cloned-offer-info")) {
      const clone = hiddenLiquidDiv.cloneNode(true);
      clone.style.display = "block";
      clone.classList.add("cloned-offer-info");
      additionalOfferDiv.parentNode.insertBefore(clone, additionalOfferDiv.nextSibling);
      // console.log("Hidden offer information cloned");
    }

    // Select first dropdown frequency item
    const ul = document.querySelector(".dropdown-custom-frequency-list");
    if (!ul) return;

    const firstLi = ul.querySelector(".dropdown-custom-frequency-item");
    if (!firstLi) return;

    setTimeout(() => {
      firstLi.click();

      // Update prices
      const priceSpan = firstLi.querySelector("span:last-of-type");
      const price = priceSpan ? priceSpan.textContent : "0.00";

      const dropdownSelected = document.querySelector(".dropdown-custom-selected");
      if (dropdownSelected) {
        let dropdownPriceSpan = dropdownSelected.querySelector("span:last-of-type");
        if (!dropdownPriceSpan) {
          dropdownPriceSpan = document.createElement("span");
          dropdownSelected.appendChild(dropdownPriceSpan);
        }
        dropdownPriceSpan.textContent = price.toFixed(0);
      }

      const offerContainer = document.querySelector(".offer-price-container");
      if (offerContainer) offerContainer.textContent = price;

      // console.log("Offer price updated:", price);

    }, 500); // slight delay to allow dropdown to render

  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


//  $(document).on("click","img.icon.icon-close",function() {  
   $(document).on("click","svg.icon.icon-close",function() {  
    $('.menu-drawer-container').removeAttr('open');
    $('.header__icon--menu').attr('aria-expanded',false);
    $('body').removeClass('overflow-hidden-tablet');
});

const progressGoals = document.querySelectorAll('.docapp-fg-progress-goal');
 
progressGoals.forEach((div, index) => {
  // index + 1 because you want numbering starting from 1
  div.classList.add(`cstm-docapp-fg-goal-completed-${index + 1}`);
});

    document.querySelectorAll('.docapp-fg-pin-cropper').forEach(cropper => {
      const img = cropper.querySelector('img');
      if(img) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('your-new-class');
        cropper.insertBefore(newDiv, img);
      }
    });
    // console.log('New div inserted above all images inside .docapp-fg-pin-cropper');
 
// 1000 milliseconds = 1 second delay

  $('.contact-query').click(function() {
    $(".contact-us-query-popup").fadeOut();
    var popupId = $(this).data('popup');
    $('#' + popupId).fadeIn();
    $("body").addClass("enable_contact_popup");
  });

  $('.contact-us-query-popup').click(function(event) {
    if ($(event.target).is('.contact-us-query-popup')) {
      $(this).fadeOut();
       $("body").removeClass("enable_contact_popup");
    }
  });

  $('.close-popup').click(function() {
    $(this).closest('.contact-us-query-popup').fadeOut();
     $("body").removeClass("enable_contact_popup");
  });






  
var banners = document.querySelectorAll('.banner-collection-sec');
    banners.forEach(function (banner) {
        if (banner.innerHTML.trim() === '') {
            banner.style.display = 'none';
        }
    });

  
         setTimeout(function(){
  var fullText = $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').text();
    var splitText = fullText.split('(');
    if (splitText.length > 1) {
        var beforeText = splitText[0];
        var afterText = '(' + splitText[1]; 
        var newText = beforeText + `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.357 7.12611C16.1344 6.90171 16.009 6.59881 16.0078 6.28277V5.21777C16.0069 4.57033 15.7493 3.94967 15.2914 3.49193C14.8335 3.0342 14.2128 2.77677 13.5653 2.7761H12.502C12.3454 2.77652 12.1903 2.74595 12.0455 2.68617C11.9008 2.62639 11.7693 2.53857 11.6587 2.42777L10.7503 1.5186C10.292 1.06143 9.67103 0.804688 9.02366 0.804688C8.37629 0.804688 7.75534 1.06143 7.29699 1.5186L6.38866 2.42777C6.27807 2.53872 6.14662 2.62669 6.00188 2.68662C5.85714 2.74654 5.70198 2.77724 5.54532 2.77694H4.48116C3.83371 2.7776 3.21296 3.03503 2.75507 3.49277C2.29718 3.9505 2.03954 4.57116 2.03866 5.2186V6.28277C2.03781 6.59848 1.91267 6.90115 1.69032 7.12527L0.780324 8.03444C0.323147 8.49278 0.0664063 9.11373 0.0664062 9.76111C0.0664062 10.4085 0.323147 11.0294 0.780324 11.4878L1.69032 12.3961C1.91287 12.6205 2.03828 12.9234 2.03949 13.2394V14.3044C2.04037 14.9519 2.29802 15.5725 2.75591 16.0303C3.2138 16.488 3.83455 16.7454 4.48199 16.7461H5.54532C5.70198 16.7458 5.85714 16.7765 6.00188 16.8364C6.14662 16.8964 6.27807 16.9843 6.38866 17.0953L7.29699 18.0044C7.75523 18.4618 8.37622 18.7187 9.02366 18.7187C9.6711 18.7187 10.2921 18.4618 10.7503 18.0044L11.6587 17.0953C11.7692 16.9843 11.9007 16.8964 12.0454 16.8364C12.1902 16.7765 12.3453 16.7458 12.502 16.7461H13.5662C14.2136 16.7454 14.8344 16.488 15.2922 16.0303C15.7501 15.5725 16.0078 14.9519 16.0087 14.3044V13.2394C16.0094 12.9235 16.1349 12.6207 16.3578 12.3969L17.267 11.4878C17.7242 11.0294 17.9809 10.4085 17.9809 9.76111C17.9809 9.11373 17.7242 8.49278 17.267 8.03444L16.357 7.12611Z" fill="#2196F3"></path>
<path d="M7.92726 12.7688C7.81943 12.7691 7.71262 12.7479 7.61303 12.7066C7.51344 12.6652 7.42305 12.6045 7.34711 12.528L5.15784 10.3387C5.01282 10.1831 4.93388 9.97724 4.93763 9.76455C4.94138 9.55187 5.02754 9.34894 5.17796 9.19852C5.32838 9.0481 5.5313 8.96194 5.74399 8.95819C5.95668 8.95444 6.16252 9.03339 6.31815 9.1784L7.92726 10.7864L11.7256 6.98914C11.8813 6.84412 12.0871 6.76517 12.2998 6.76893C12.5125 6.77268 12.7154 6.85884 12.8658 7.00926C13.0162 7.15967 13.1024 7.3626 13.1062 7.57529C13.1099 7.78798 13.031 7.99382 12.8859 8.14945L8.50741 12.528C8.43147 12.6045 8.34108 12.6652 8.24149 12.7066C8.1419 12.7479 8.03509 12.7691 7.92726 12.7688Z" fill="white"></path>
</svg>` + afterText;
        $('.product__info-wrapper .jdgm-widget .jdgm-prev-badge__text').html(newText);
    }
         },550);

 let swiper = new Swiper('.how-to-use-product-listing', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3.5,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
          breakpoints: {
        1200: {   
            slidesPerView: 3.2,
            spaceBetween: 10
        },
        992: {    
            slidesPerView: 2.5,
            spaceBetween: 20
        },
        749: {    // tablet
            slidesPerView: 2.2,
            spaceBetween: 20
        },
        // 480: {    // mobile
        //     slidesPerView: 2.3,
        //     spaceBetween: 10
        // },
        500: {    // mobile
            slidesPerView: 2.6,
            spaceBetween: 10
        }
        }
    });
    
    var initialTitle = $('.main_setps.active').data('title'); 
    $('.main-step-content-wrapper').each(function() {
        var contentTitle = $(this).data('title');
        if (contentTitle === initialTitle) {
            $(this).show(); 
        } else {
            $(this).hide();
        }
    });

    //original code start
  
    // $('.main_setps').click(function() {
    //     var title = $(this).attr('data-title');
    //     $('.main_setps').removeClass('active');
    //     $(this).addClass('active');
        
    //     $('.main-step-content-wrapper').each(function() {
    //         var contentTitle = $(this).attr('data-title');
    //                       $(".main-step-content-wrapper").hide();
    //         if (contentTitle === title) {
    //             $(this).show();  
    //             console.log('swiper = ', swiper);
                
    //           swiper.destroy(true, true);
    //           swiper = new Swiper('.how-to-use-product-listing', {
    //           loop: true,
    //           slidesPerView: 3.5,
    //           spaceBetween: 30,
    //         });
              
    //         } 
    //     });
    // });
    
    //original code end
//console error
 
$('.main_setps').click(function() {
    var title = $(this).attr('data-title');

    $('.main_setps').removeClass('active');
    $(this).addClass('active');

    $(".main-step-content-wrapper").hide();

    $('.main-step-content-wrapper').each(function() {
        var contentTitle = $(this).attr('data-title');

        if (contentTitle === title) {
            $(this).show();

            // Refresh existing swiper instead of destroying
            if (Array.isArray(swiper)) {
                swiper.forEach(function(instance) {
                    if (instance && typeof instance.update === 'function') {
                        instance.update();
                    }
                });
            }
        }
    });
});

 
//console error



    $('.main-step-content-wrapper').hide();
  if($(".main_setps .steps").hasClass("active")){
    $('.steps.active').each(function() {
        $(this).closest('.main_setps').trigger('click');
    });
  }else{
     $('.main-step-content-wrapper').first().show();
  }
    



  
 $('.subscription_custom_wrap .input-wrapper').click(function(){
    $('.input-wrapper').removeClass('checked')
    $(this).addClass('checked')
});


 $(document).on("click",".bottom-text-wraper",function() {
    $(".more-info-data-container").slideToggle();
       $(this).toggleClass('active');
  });

  var tag_fre_pro_attr= $('body').attr('free_pro_attr');
              var tag_fre_pro_id= $('body').attr('free-pro-data-attr');
             if(tag_fre_pro_attr == 'false'){
              $.ajax({
                          url: "/cart",
                          type: "GET",
                          dataType: "html",
                          success: function (t) {
                            $("cart-drawer-items").html($(t).find("cart-drawer-items").html());
                              $(".cart-item").each(function () {
                                var itemId = $(this).attr("item_id"); 
                             var fre_pro_line_item_attr = $(this).attr('fre_pro_attr');
                               if(fre_pro_line_item_attr){
                                  var deleted_pro_id = $(this).attr("item_id");
                                  jQuery.ajax({
                                type: 'POST',
                                url: '/cart/change.js',
                                 async : false,
                                data: { quantity: 0,id: deleted_pro_id},
                                dataType: 'json',
                                  success: function (data) { 
                                  $.ajax({
                                   url: '/cart',
                                   type: "GET",
                                   dataType: "html",
                                       success: function(data) {
                                          $("#CartDrawer").html($(data).find('#CartDrawer').html());
                                            var productLenght = $('tr.cart-item').length;
                                           if(productLenght==0){
                                           $('cart-drawer.drawer').addClass('is-empty');
                                             $('#main-cart-footer').addClass('is-empty');
                                          $('cart-items.gradient').addClass('is-empty');
                                          }   
                                       $('.cart-count-bubble').html($(data).find('#CartDrawer .cart-item').length);
                                         $('.cart-count-bubble').html($(data).find('.cart-count-bubble').html());
                                          $('.cart__items').html($(data).find('.cart__items').html());
                                       },
                                    });
                                  }
                               })
                                }
                             });
          },
                      });
              }
                

$(document).on('click','.st-search-icon',function(){
$('.st-mobile-searchbox ').attr('style','display: block !important')
});
  $(document).on('click','.copied_content',function(){
     $('.copied').text('Copy Code');
$(this).parents('.coupon_code_list').find('.copied').text('Copied!');
  
});
$(document).on("click", ".collection ul.tabs li", function () {

  var $collectionWrap = $(this).parents(".collection");
  var Collectionlink = $(this).attr("collection-url");
  var tab_id = $(this).attr("data-tab");
  var $tabContent = $collectionWrap.find("#" + tab_id);
  var $tabLi = $(this);

  $collectionWrap.find("a.link.underlined-link").attr("href", Collectionlink);
  $collectionWrap.find("ul.tabs li").removeClass("current");

  function revealTab() {
    $collectionWrap.find(".tab-content").removeClass("current").css({
      opacity: "0",
      display: "none"
    });

    $tabContent.css({ display: "block" });

    // force reflow taaki transition reliably trigger ho
    void $tabContent[0].offsetWidth;

    requestAnimationFrame(function () {
      $tabContent.addClass("current");
      $tabContent.css("opacity", "1");
      window.dispatchEvent(new Event("resize")); // Swiper re-init/recalculate
    });

    $tabLi.addClass("current");
  }

  // function staggerRevealProducts() {
  //   var $items = $tabContent.find(".swiper-wrapper > li");
  //   var staggerDelay = 120; // thoda tight aur smooth feel ke liye

  //   $items.css({
  //     opacity: 0,
  //     transform: "translateY(12px)",
  //     transition: "none"
  //   });

  //   $items.each(function (i, el) {
  //     setTimeout(function () {
  //       $(el).css("transition", "opacity 0.5s ease, transform 0.5s ease");
  //       requestAnimationFrame(function () {
  //         $(el).css({ opacity: 1, transform: "translateY(0)" });
  //       });
  //     }, i * staggerDelay);
  //   });
  // }

  function staggerRevealProducts() {
  var $items = $tabContent.find(".swiper-wrapper > li");
  var staggerDelay = 150; // har product ke beech ka gap (ms) — apne hisaab se badha/ghata sakte hain

  // pehle sabko reset karo (hidden state, no animation)
  $items.removeClass("stagger-in").css({
    opacity: 0,
    transform: "translateY(14px)",
    "animation-delay": ""
  });

  // force reflow taaki animation restart ho (repeat click pe bhi kaam kare)
  void $tabContent[0].offsetWidth;

  $items.each(function (i, el) {
    $(el).css("animation-delay", (i * staggerDelay) + "ms");
  });

  // ek chhoti si delay ke baad class add karo taaki animation trigger ho
  requestAnimationFrame(function () {
    $items.addClass("stagger-in");
  });
}
  var alreadyLoaded = $tabContent.attr("data-products-loaded") === "true";

  if (alreadyLoaded) {
    revealTab();
    staggerRevealProducts();
    return;
  }

  var fetchUrl = Collectionlink + (Collectionlink.indexOf("?") > -1 ? "&" : "?") + "view=tab-ajax";

  $.ajax({
    url: fetchUrl,
    method: "GET",
    success: function (html) {
      $tabContent.find(".swiper-wrapper").html(html);
      $tabContent.attr("data-products-loaded", "true");
      revealTab();
      staggerRevealProducts();
    },
    error: function (xhr) {
      console.error("Failed to load products for tab:", tab_id, xhr.status);
      revealTab();
    },
  });
});
$(document).ready(function () {
  // Page load hone ke thodi der baad background preloading start karein
  setTimeout(function () {
    $(".collection").each(function () {
      var $collectionWrap = $(this);
      
      $collectionWrap.find("ul.tabs li").each(function (index) {
        if (index === 0) return; // Pehla tab chhod dein
        
        var $tabLi = $(this);
        var Collectionlink = $tabLi.attr("collection-url");
        var tab_id = $tabLi.attr("data-tab");
        var $tabContent = $collectionWrap.find("#" + tab_id);
        
        var alreadyLoaded = $tabContent.attr("data-products-loaded") === "true";
        if (alreadyLoaded) return;

        var fetchUrl = Collectionlink + (Collectionlink.indexOf("?") > -1 ? "&" : "?") + "view=tab-ajax";

        // Background AJAX call
        $.ajax({
          url: fetchUrl,
          method: "GET",
          success: function (html) {
            $tabContent.find(".swiper-wrapper").html(html);
            $tabContent.attr("data-products-loaded", "true");
          }
        });
      });
    });
  }, 1000); // 1000ms = 1 second baad background load shuru hoga
});

$(document).on("click",".testimoniols-tab-link",function() {
    $('.custom-collection-tab').css('opacity','1')
    setTimeout(function(){window.dispatchEvent(new Event('resize'));},100)  
		var testimonials_tab_id = $(this).attr('testimonials-data-tab');
		$('.testimoniols-tab-link').removeClass('testimonials-current');
		$('.testimonials-current').removeClass('testimonials-current');
		$(this).addClass('testimonials-current');
		$("#"+testimonials_tab_id).addClass('testimonials-current');
});
  var Swipes1 = new Swiper('.collection-swiper-container', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: false 
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            480: {
                slidesPerView:'auto',
                spaceBetween: 10
            }
        }
    });
     var Swipes1 = new Swiper('.collection-swiper-container_new', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 20,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
         draggable: true 
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            749: {
                slidesPerView: 'auto',
                spaceBetween: 30
            },
            480: {
                slidesPerView:'auto',
                spaceBetween: 10,
                 scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
              draggable: false 
              },
            }
        }
    });


    
setTimeout(function(){$('body .custom-collection-tab').css('opacity','1')},700)
 var swiper2 = new Swiper('.swiper-container', {  
    pagination: {
         nextEl: '.testimonials-swiper-button-nextt',
         prevEl: '.testimonials-swiper-button-prevv',
       },
    pagination: '.swiper-pagination1, .swiper-pagination2',
      paginationClickable: true,
  });

//Ms Clarity app issue 

if (window.matchMedia("(max-width: 749px)").matches){

    const mobileSwiperEl = document.querySelector('.mobile-swiper-container');
    if (mobileSwiperEl && mobileSwiperEl.querySelector('.swiper-scrollbar')) {
      var Swipesc = new Swiper('.mobile-swiper-container', {   
          loop: false,       
          slidesPerView: 'auto',
          spaceBetween: 20,
           scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true
          }
      });
    } else if (mobileSwiperEl) {
      // scrollbar element nahi mila, bina scrollbar ke initialize karo
      var Swipesc = new Swiper('.mobile-swiper-container', {   
          loop: false,       
          slidesPerView: 'auto',
          spaceBetween: 20
      });
    }

    const iconTextSwiperEl = document.querySelector('.icon-text-swiper');
    if (iconTextSwiperEl && iconTextSwiperEl.querySelector('.swiper-scrollbar')) {
      var SwipesP = new Swiper('.icon-text-swiper', {   
          loop: false,       
          slidesPerView: 'auto',
          spaceBetween: 20,
           scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true
          } 
      });
    } else if (iconTextSwiperEl) {
      var SwipesP = new Swiper('.icon-text-swiper', {   
          loop: false,       
          slidesPerView: 'auto',
          spaceBetween: 20
      });
    }
}



  $(document).on("click",".read_more",function() { 
    $('.half_content').hide();
    $('.full_content').show();
  });
    $(document).on("click",".read_less",function() { 
    $('.half_content').show();
    $('.full_content').hide();
  });
  
 if (window.matchMedia("(max-width: 989px)").matches){ 
   
var heights = $(".collection-swiper-container ul").map(function ()
    {
        return $(this).height();
    }).get();

   
maxHeight = Math.max.apply(null, heights);
$('.collection-swiper-container ul li').css('height' , maxHeight);
  
  // $(document).on("click","a.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
  //   // $('.st-autocomplete-box-container').toggle();
  //   $('.st-autocomplete-box-container').show();
  // });

    $(document).on("click","span.site-nav__link.site-nav__link--icon.st-search-icon.hidden-desktop",function() {   
     $('.st-autocomplete-box-container').toggle();
     $('body').toggleClass('st-no-scroll');
  });


   $(document).mouseup(function (e) {
     var popup = $(".st-autocomplete-box-container");
     if (!$('input#st-mobile-autocomplete-search-bar').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0 && !$('.st-searchicon').is(e.target)) {     
       popup.hide();
        $('body').removeClass('st-no-scroll');
       
     }
 });


 
   
 }

  
});

function copyToClipboard(element) {  
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();  
}





/*** Share button click Event ***/
$('#share-toggle-button,.share-button__button').click(function(){
  const userAgent = navigator.userAgent.toLowerCase();
  const isLinux = userAgent.includes('linux');
  const isFirefox = userAgent.includes('firefox');

  if (navigator.share && $(window).width() < 20067) {
    navigator.share({
      title: this.hasAttribute("share-title") ? this.getAttribute("share-title") : document.title,
      url: this.hasAttribute("share-url") ? this.getAttribute("share-url") : window.location.href
    });
  } else {
    if ($(this).parents('.product-meta__share').find('.popover[open]').length > 0) {
      $(this).parents('.product-meta__share').find('.popover').removeAttr('open', false);
    } else {
      $(this).parents('.product-meta__share').find('.popover').attr('open', true);
    }
  }

  // Show .pdp_desk_share if OS is Linux OR browser is Firefox
  if (isLinux || isFirefox) {
    $('.pdp_desk_share').css('display', 'flex');
  }
});
 $('.popover__close-button').click(function(){
 $(this).parents('.popover').attr('open',false);
})
 
/*** Share button click Event END here***/
  /* hide popup outer from container */
   if($('body').hasClass('cstm-product') && $('.popover,.popover__header').length > 0){
   document.addEventListener('mouseup', function(e) {
    var container = $('.popover,.popover__header');
    //  console.log(e);
    if (!container.is(e.target) && !$(".close").is(e.target)) {
        var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
        $(container).attr('open',false)
    }
}); 
   }
  /* hide popup outer from container END*/



// Define the setCookie function globally
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

$(document).ready(function() {
    var modal = $("#myModal");
  var delay_range = parseInt(modal.attr('delay_range'));
  var delay_range_value = delay_range * 1000;
     var modalClosed = getCookie("modalClosed");
  var modalClosedd = getCookie("modalClosedd")
     if (!modalClosed && !modalClosedd && window.location.href.indexOf("challenge") <0) {
        setTimeout(function() {
        modal.css("display", "block");
        }, delay_range_value);
    }
  if(window.location.href.indexOf('form_type=customer') > -1 || window.location.href.indexOf('customer_posted=true') > -1){
    modal.css("display", "block");
    $('.newsletter-form__field-wrapper').hide();
        $('button#Subscribe').hide();
     $('.after_subscription_message').show();
      var after_sub_heading = $('.after_subscription_heading').text();
    var before_sub_heading =  $('#subs-heading').text(after_sub_heading);
    var after_sub_desc = $('.after_subscription_desc').text();
    var before_sub_desc =  $('#subs-desc').text(after_sub_desc);
   
  }
  function cookiesData(day_range,hours_range,range_type){
      if(range_type == 'days'){
          var totalMilliseconds = (day_range * 24 * 60 * 60 * 1000);
        } else{
          var totalMilliseconds = (hours_range * 60 * 60 * 1000);
        } 
        setCookie("modalClosed", true, totalMilliseconds); 
  }
$(".close").click(function() {
    var modal = $(this).closest('.modal'); 

    var day_range = parseInt(modal.attr('day_range')); 
    var hours_range = parseInt(modal.attr('hours_range')); 
    var range_type = modal.attr('data_range_type'); 
        modal.css("display", "none");
      cookiesData(day_range,hours_range,range_type);
     var main_url = window.location.href.split('?')[0];
        history.pushState({urlPath:main_url},"",main_url);
});
$(window).click(function(event) {
    var modal =$('#myModal');
       var day_range = parseInt(modal.attr('day_range'));
      var hours_range = parseInt(modal.attr('hours_range'));
     var range_type = modal.attr('data_range_type'); 
        if ($(event.target).is("#myModal")) {
            modal.css("display", "none");
           cookiesData(day_range,hours_range,range_type);
        }
    });

function setCookie(name, value, milliseconds) {
    var expires = "";
    if (milliseconds) {
        var date = new Date();
        date.setTime(date.getTime() + milliseconds);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

    
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});
//========================== product-slider=============== //


  var mainSwiper;
var thumbSwiper;

function initProductSlider() {

  if (!$("body").hasClass('cstm-product')) return;

  // Destroy previous instances (important!)
  if (mainSwiper) mainSwiper.destroy(true, true);
  if (thumbSwiper) thumbSwiper.destroy(true, true);

  // THUMBS FIRST
  thumbSwiper = new Swiper('.carousel-main-new', {
    direction: 'vertical',
    slidesPerView: 4,
    spaceBetween: 10,
    initialSlide: 0,
    loop: false,
    freeMode: true,
    mousewheel: true,
    observer: true,
    observeParents: true,
    watchSlidesProgress: true,
  });

  // MAIN
  mainSwiper = new Swiper('.carousel-main', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    initialSlide: 0,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

}


document.addEventListener('DOMContentLoaded', function () {
  initProductSlider();

  let resizeTimer;   // ← YE LINE ADD/UNCOMMENT KARO

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initProductSlider();
    }, 300);
  });
});
//ms clarity app REDING STYLE 

$(document).ready(function() {
  if ($('.desktop_container .swiper-arrow-desktop').length > 0) {
    const carousel = document.querySelector('.desktop_container');
    const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
    const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');

    if (prev && next) {
      prev.style.display = 'none';
      next.style.display = 'none';

      carousel.addEventListener('mousemove', (e) => {
        const rect = carousel.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const half = rect.width / 2;

        if (x < half) {
          prev.style.left = `${x}px`;
          prev.style.top = `${y}px`;
          prev.style.display = 'block';
          next.style.display = 'none';
        } else {
          next.style.left = `${x}px`;
          next.style.top = `${y}px`;
          next.style.display = 'block';
          prev.style.display = 'none';
        }
      });

      carousel.addEventListener('mouseleave', () => {
        prev.style.display = 'none';
        next.style.display = 'none';
      });
    }
  }
});


//mS CLARITY 


$(document).ready(function() {
  if ($('.cstm-product').length === 0) return;

  if ($('.desktop_container .swiper-arrow-desktop').length > 0) {
    const carousel = document.querySelector('.desktop_container');
    const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
    const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');

    if (prev && next) {
      prev.style.display = 'none';
      next.style.display = 'none';

      carousel.addEventListener('mousemove', (e) => {
        const rect = carousel.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const half = rect.width / 2;

        if (x < half) {
          prev.style.left = `${x}px`;
          prev.style.top = `${y}px`;
          prev.style.display = 'block';
          next.style.display = 'none';
        } else {
          next.style.left = `${x}px`;
          next.style.top = `${y}px`;
          next.style.display = 'block';
          prev.style.display = 'none';
        }
      });

      carousel.addEventListener('mouseleave', () => {
        prev.style.display = 'none';
        next.style.display = 'none';
      });
    }
  }
});


$(document).ready(function() {
  if($(".new-swiper").length > 0){
     initSwiper();
  var swiper = new Swiper(".new-swiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,  // Default state for the scrollbar
      draggable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.9,
        spaceBetween: 10,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
        },
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          draggable: true,
        },
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true, 
          draggable: true,
        },
      },
    },
  });

  $(window).resize(function() {
    //  alert("here resize");
    var windowWidth = $(window).width();
    if (windowWidth >= 1024) {
      swiper.params.scrollbar.hide = true;  
    } else {
      swiper.params.scrollbar.hide = false; 
    }
    swiper.update(); 
  });
}
});


$(document).ready(function() {
if($('.desktop_container .swiper-arrow-desktop').length > 0){
const carousel = document.querySelector('.desktop_container');
  const prev = carousel.querySelector('.swiper-arrow-desktop.slick-prev');
  const next = carousel.querySelector('.swiper-arrow-desktop.slick-next');
   prev.style.display = 'none';
  next.style.display = 'none';
  carousel.addEventListener('mousemove', (e) => {
    const rect = carousel.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const half = rect.width / 2;
 
    // Position buttons at cursor location
    if (x < half) {
      prev.style.left = `${x}px`;
      prev.style.top = `${y}px`;
      prev.style.display = 'block';
      next.style.display = 'none';
    } else {
      next.style.left = `${x}px`;
      next.style.top = `${y}px`;
      next.style.display = 'block';
      prev.style.display = 'none';
    }
  });
 
  carousel.addEventListener('mouseleave', () => {
    prev.style.display = 'none';
    next.style.display = 'none';
  });
}
});

$(document).ready(function () {
  $(document).on('click', function () {
    const opacity = parseFloat($('#custom-cursor').css('opacity'));

    if (opacity === 1) {
      $('.drawer').removeClass('active');
      $('body').removeClass('overflow-hidden');
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
// Step 0: Declare outside to use later if needed
if($("product-form.product-form input.product-variant-id").length > 0 && $('.variants_class').length > 0){
let selectedVariantId = null;
let selectedPrice = null;
let selectedCompareAtPrice = null;

// Step 1: Get selected variant ID
let selectedId = $("product-form.product-form input.product-variant-id").val();
// console.log("selectedId"+selectedId);
// Step 2: Parse variants JSON

let jsonText = $('.variants_class').text();

let variantsData = JSON.parse(jsonText);

// console.log(variantsData);

let selectedVariant;

if (Array.isArray(variantsData)) {
    // If it's an array, find the matching variant by id
    selectedVariant = variantsData.find(variant => variant.id == selectedId);
} else if (typeof variantsData === 'object' && variantsData !== null) {
    // If it's a single object (not an array), treat it like the first variant
    selectedVariant = variantsData;  // no need for [0], it's already the object
} else {
    // If variantsData is not an array or object (null or something else), handle it safely
    selectedVariant = null;
}

// Step 4: If match found, update values and DOM
if (selectedVariant) {
    selectedVariantId = selectedVariant.id;
    selectedPrice = selectedVariant.price;
    selectedCompareAtPrice = selectedVariant.compare_at_price;

    const formatMoney = (amount) => {
      return '₹' + (amount / 100).toFixed(2); 
    };

    const formattedPrice = formatMoney(selectedPrice);
    const formattedComparePrice = formatMoney(selectedCompareAtPrice);
    const saveAmountRaw = selectedCompareAtPrice - selectedPrice;
    const formattedSaveAmount = formatMoney(saveAmountRaw);

    const saveText = `You’ll save ${formattedSaveAmount}`;
    const stickyElement = document.getElementById("cstm-addtocart-sticky");

if (stickyElement) {
    // Render into .price
    const priceElement = stickyElement.querySelector(".price");
    const comparePriceElement = stickyElement.querySelector(".compare-price");

    if (priceElement) {
      priceElement.textContent = formattedPrice;
    }

   const numericComparePrice = parseFloat(formattedComparePrice.replace(/[^\d.-]/g, ""));

// Now check if numericComparePrice is > 0
if (numericComparePrice > 0) {
  // Show compare price
  comparePriceElement.textContent = formattedComparePrice;
  comparePriceElement.style.display = "";
} else {
  // Hide compare price
  comparePriceElement.textContent = "";
  comparePriceElement.style.display = "none";
}

const saveTextElement = stickyElement.querySelector(".save_text");
if (saveTextElement) {
  if (saveAmountRaw > 0) {
    saveTextElement.textContent = saveText;
    saveTextElement.style.display = "";  // show element
  } else {
    saveTextElement.textContent = "";
    saveTextElement.style.display = "none";  // hide element
  }
}
} else {
    console.log("No variant found with ID:", selectedId);
}
}
}
//   // 🛒 Add to cart handler
 $('#add-to-cart-btn').off('click').on('click', function (e) {
    e.preventDefault();
    const btn = $(this);
 
    // Point 6: if already in "View Cart" state, open the drawer instead of adding again
    if (btn.attr('data-cart-state') === 'view') {
      $('#sticky_content').hide();
 
      $('#view_cart').trigger('click');
      return;
    }
 
    const selectedStickyItem = document.querySelector('#cstm-addtocart-sticky .sticky-variant-item.selected');
    let selectedId = selectedStickyItem
      ? selectedStickyItem.dataset.variantId
      : $("product-form.product-form input.product-variant-id").val();
 
    btn.addClass('newLoad');
    setTimeout(function () {
      btn.removeClass('newLoad');
    }, 2000);
 
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        quantity: 1,
        id: selectedId
      },
      success: function (data) {
        // Cache the button element safely beforehand if needed
        // var $addToCart = $('#your-button-id'); 

        // Trigger standard Shopify custom events
        $('body').trigger('added.ajaxProduct');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));

        // Fetch fresh cart state once
        jQuery.getJSON('/cart.js', function (cart) {
          const cartCount = Number(cart.item_count || 0);

          // 1. Update Cart Bubble Counter directly using data from cart.js
          const cartIcon = document.getElementById('cart-icon-bubble');
          if (cartIcon) {
            let cartBubble = cartIcon.querySelector('.cart-count-bubble');

            if (cartCount > 0 && !cartBubble) {
              cartBubble = document.createElement('div');
              cartBubble.className = 'cart-count-bubble';
              cartIcon.appendChild(cartBubble);
            }

            if (cartBubble) {
              if (cartCount > 0) {
                const countSpan = cartBubble.querySelector('span');
                if (countSpan) {
                  countSpan.textContent = cartCount;
                } else {
                  cartBubble.textContent = cartCount;
                }
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            }
          }

          // 2. Handle Cart Drawer updates & visibility
          // If using Dawn theme architecture, it's safer to load via section rendering, 
          // but keeping your DOM manipulation structure fixed:
          $("cart-drawer").removeClass("is-empty");
          $(".drawer__inner-empty").hide(); // Fixed missing dot selector

          // Optional: reload drawer contents via section endpoint if supported by theme
          $("cart-drawer").load("/cart #CartDrawer", function() {
            // Open drawer smoothly after content loads
            setTimeout(function () {
              $('.drawer').addClass('animate active');
            }, 300);
          });
        });

        // Flip the sticky button state
        if (typeof window.stickyRefreshButtonState === 'function') {
          window.stickyRefreshButtonState(selectedId);
        }
      },
      error: function (xhr, status, error) {
        console.error("Error adding to cart: ", error);
      }
    });
  });

function onload(){
    const overlay = document.getElementById('CartDrawer-Overlay');
      const cursor = document.getElementById('custom-cursor');
    
      overlay.addEventListener('mousemove', (e) => {
        cursor.style.opacity = '1';
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
      });
    
      overlay.addEventListener('mouseenter', () => {
        cursor.style.opacity = '1';
      });
    
      overlay.addEventListener('mouseleave', () => {
        cursor.style.opacity = '0';
      });
    };
  

});
  $('#view_cart').on('click', function (e) {
    e.preventDefault();

    // Animate and show cart
    setTimeout(function () {
        $(".drawer").addClass("animate active"); // Updated selector
    }, 1000);

    // Attach custom cursor events
    setTimeout(function () {
        const overlay = document.getElementById('CartDrawer-Overlay');
        const cursor = document.getElementById('custom-cursor');

        if (overlay && cursor) {
            // To prevent adding multiple event listeners
            if (!overlay.dataset.cursorSetup) {
                overlay.addEventListener('mousemove', (e) => {
                    cursor.style.opacity = '1';
                    cursor.style.left = e.clientX + 'px';
                    cursor.style.top = e.clientY + 'px';
                });

                overlay.addEventListener('mouseenter', () => {
                    cursor.style.opacity = '1';
                });

                overlay.addEventListener('mouseleave', () => {
                    cursor.style.opacity = '0';
                });

                // Mark as initialized
                overlay.dataset.cursorSetup = 'true';
            }
        } else {
            console.warn("Overlay or custom cursor element not found.");
        }
         let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
              console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1300);

    // Prevent scroll
    setTimeout(function () {
        $('body').addClass("overflow-hidden");
        let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
              console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1500);
});

function updateCartBubble() {
  let cartCount = null;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cartCount = cart.item_count;
      console.log("cartCount"+cartCount);
 
      const cartBubble = document.querySelector('.cart-count-bubble');
 
      if (cartCount > 0) {
        cartBubble.textContent = cartCount;
        cartBubble.classList.remove('hide');
      } else {
        cartBubble.classList.add('hide');
      }
    })
    .catch(error => console.error('Cart update error:', error));
}



 $(document).ready(function() {
  if($("body").hasClass('cstm-product') == false){
  var thumbSwiper = new Swiper('.carousel-main-new', {
    loop: false,
    slidesPerView: 5,
    spaceBetween: 15,

    grabCursor: true,
    thumbs: {
      swiper: mainSwiper,
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  breakpoints: {
      768: {
        slidesPerView: 3 ,
        navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      }
    },
  });

  var mainSwiper = new Swiper('.carousel-main', {
    loop: false,
    freeMode: {
      enabled: true,
      momentum: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });

  }


// $(document).on('click', '.input-label-wrapper', function() {
//   var getImageurl = $(this).find('.variantfirstimg').attr('src');
//   getImageurl = getImageurl.replace(/&amp;/g, '&');
//   var cleanUrl = getImageurl.replace(/(&|\?)width=\d+/g, '');
//   $('.variant_specific_image img').attr('src', cleanUrl);
//    setTimeout(function() {
//       mainSwiper.slideTo(0);
//       thumbSwiper.slideTo(0);
//     }, 50);
// });


//to solve the console errors 

$(document).on('click', '.input-label-wrapper', function () {

  var getImageurl = $(this).find('.variantfirstimg').attr('src');

  if (!getImageurl) return;

  getImageurl = getImageurl.replace(/&amp;/g, '&');
  var cleanUrl = getImageurl.replace(/(&|\?)width=\d+/g, '');

  $('.variant_specific_image img').attr('src', cleanUrl);

  setTimeout(function () {

    // SAFE CHECK: prevent "undefined slideTo error"
    if (typeof window.mainSwiper !== "undefined" &&
        window.mainSwiper &&
        typeof window.mainSwiper.slideTo === "function") {
      window.mainSwiper.slideTo(0);
    }

    if (typeof window.thumbSwiper !== "undefined" &&
        window.thumbSwiper &&
        typeof window.thumbSwiper.slideTo === "function") {
      window.thumbSwiper.slideTo(0);
    }

  }, 50);

});

//to solve the console errors 


$(document).on('change', 'select[name="id"]', function() {
  var selectedVariantImage = $(this).find('option:selected').data('image-url');
  if(selectedVariantImage) {
    var cleanUrl = selectedVariantImage.replace(/&amp;/g, '&').replace(/(&|\?)width=\d+/g, '');
    $('.variant_specific_image img').attr('src', cleanUrl);
  }
});
var mySwiperInstance;
setTimeout(function(){

//********** location block slider start  *************/ 
 mySwiperInstance = new Swiper('.swiper-location-active', {   
        loop: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 3,   
        paginationClickable: true,      
        spaceBetween: 8,
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 8, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
  pagination: {
          el: '.swiper-paginationjtpl',
          clickable: true,
          dynamicBullets: true
      },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  },
         scrollbar: {
          el: ".swiper-scrollbar-jtpl",
          hide: true,
         draggable: true 
        },
        breakpoints: {
            1920: {
                slidesPerView: 3,
                spaceBetween: 8
            },
            982: {
                slidesPerView: 2,
                spaceBetween: 8
            },
            767: {
                slidesPerView: 1,
                spaceBetween: 8
            }
        }
    });
//********** location block slider end  *************/ 

//********** Review block image slider start  *************/ 
    var Swipes4 = new Swiper('.review-image-slider', {   
        loop: false,
        slidesPerView: 5,   
        paginationClickable: true,      
        spaceBetween: 13,
        navigation: {
        nextEl: '.swiper-button-next-jt',
        prevEl: '.swiper-button-prev-jt',
      },
       // mousewheelControl: true,         
        freeMode: true,
       loopedSlides: 10, // according to the codepen
    followFinger: true,
  //     mousewheel: {
  //   releaseOnEdges: true,
  // },
    keyboard: {
    enabled: true, // enable keyboard navigation
    onlyInViewport: false, // allow keyboard outside the viewport
  }
    });
//********** Review block image slider end  *************/ 

//********** City block slider start  *************/ 
      var Swipes2 = new Swiper('.active-slider', {   
          loop: false,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          slidesPerView: 5.4,   
          paginationClickable: true,      
          spaceBetween: 16,
        // mousewheelControl: true,         
          freeMode: true,
        loopedSlides: 8, // according to the codepen
      followFinger: true,
    //     mousewheel: {
    //   releaseOnEdges: true,
    // },
    pagination: {
          el: '.swiper-pagination-jt',
          clickable: true,
          dynamicBullets: true
      },
      keyboard: {
      enabled: true, // enable keyboard navigation
      onlyInViewport: false, // allow keyboard outside the viewport
    },
          breakpoints: {
              1920: {
                  slidesPerView: 5.4,
                  spaceBetween: 16
              },
              1200: {
                  slidesPerView: 4.4,
                  spaceBetween: 16
              },
              767: {
                  slidesPerView: 3,
                  spaceBetween: 8
              }
          }
      });
//********** City block slider end  *************/ 

//********** State block slider start  *************/ 
  var Swipes3 = null;
    function initSwiper() {
      // alert("here init");
  Swipes3 = new Swiper('.active-slider-state', {   
          loop: false,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev',
          slidesPerView: 5.4,   
          paginationClickable: true,      
          spaceBetween: 16,
        // mousewheelControl: true,         
          freeMode: true,
        loopedSlides: 8, // according to the codepen
      followFinger: true,
    //     mousewheel: {
    //   releaseOnEdges: true,
    // },
      keyboard: {
      enabled: true, // enable keyboard navigation
      onlyInViewport: false, // allow keyboard outside the viewport
    },
          breakpoints: {
              1920: {
                  slidesPerView: 5.4,
                  spaceBetween: 16
              },
              1200: {
                  slidesPerView: 4.4,
                  spaceBetween: 16
              },
              767: {
                  slidesPerView: 3,
                  spaceBetween: 8
              }
          }
      });
    }
    initSwiper();
//********** State block slider end  *************/ 
  }, 500);
  setTimeout(function(){
    const style = document.createElement("style");
        style.textContent = `
          .city-content-main-wrapper {
              display: none;
          }
          .city-content-main-wrapper.active-state-one {
              display: block;
          }
          .location-wrapper-main{
            display: none;
          } 
          .location-wrapper-main.location-active{
            display: block;
          }
          .swiper-scrollbar-jtpl,
          .swiper-paginationjtpl{
            opacity: 0;
          }
          .location-active .swiper-scrollbar-jtpl{
            opacity: 1;
          }
          @media (max-width: 767px){
            .location-active .swiper-paginationjtpl{
              opacity: 1;
            }
          }
        `;
        document.head.appendChild(style);
    }, 700);
  
  $(".location-wrapper-main").each(function(){
      $(".location-wrapper-main").removeClass("location-active");
      $(".location-wrapper-main").first().addClass("location-active");
      $(".location-wrapper-main").first().trigger("click");
  });


  $(document).ready(function(){

    $(".location-wrapper-main").removeClass("location-active");

    let firstState = $(".state-name").first().attr("state-name");

    $('.location-wrapper-main[state-name="' + firstState + '"]')
    .first()
    .addClass("location-active");

});

   
$(".state-name").on("click", function(){

    let stateName = $(this).attr("state-name");

    $(".state-name").removeClass("active-state");
    $(this).addClass("active-state");


    $(".location-wrapper-main")
    .removeClass("location-active");


    $('.location-wrapper-main[state-name="' + stateName + '"]')
    .first()
    .addClass("location-active");


    if(typeof initSwiper === "function"){
        initSwiper();
    }

});

    $(".share-text-btn").each(function(){
      $(this).click(function(){
          if($(this).parents(".location-share-wrapper").find(".review-share-popup").hasClass("active-popup")){
              $(this).parents(".location-share-wrapper").find(".review-share-popup").removeClass("active-popup");
          }else{
          $(this).parents(".location-share-wrapper").find(".review-share-popup").addClass("active-popup");
          }
      }); 
    });
    $(document).click(function (e) {
        setTimeout(function () {
            if (!$(e.target).closest(".share-button__button").length && !$(e.target).closest(".pdp_desk_share").length) {
                $(".share-button details").removeAttr("open");
                $(".share-button details .share-button__button").attr("aria-expanded", "false");
            }
            if (!$(e.target).closest(".review-btn-slider").length && !$(e.target).closest(".review-image-jtpl").length) {
                 $("body").removeClass("review-popup-open");
                 $(".visit-us-review-popup-wrapper").remove();
            }
        }, 100);
    });

    $(".review-image-jtpl").click(function () {
      $("body").addClass("review-popup-open");
      $(".visit-us-review-popup-wrapper").remove();
      var allImages = $(this).parents(".review-image-slider")
        .find(".review-image-jtpl img");
    var clickedIndex = allImages.index($(this).find("img"));
    var slides = "";
    $(this).parents(".review-image-slider")
        .find(".review-image-jtpl img")
        .each(function () {
            var imgSrc = $(this).attr("src");

            slides += `
                <div class="swiper-slide">
                    <img src="${imgSrc}" alt="" loading="lazy" fetchpriority="auto" >
                </div>
            `;
        });
      $("body").append(`
          <div class="visit-us-review-popup-wrapper">
            <div class="visit-us-review-popup-inner">
                <div class="visit-us-review-popup-slider">
                    <div class="swiper-wrapper">
                        ${slides}
                    </div>
                    <div class="popup-slider-button review-btn-slider">
                      <div class="swiper-prev-review">
                        <svg width="7" height="9" viewBox="0 0 7 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.1875 7.959L1.8125 4.58398L5.1875 1.20898" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                      <div class="review-popup-close-btn review-btn-slider">
                        <span class="close-popup-review">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.75 12.75L12.75 0.75M0.75 0.75L12.75 12.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </span>
                      </div>
                      <div class="swiper-next-review review-btn-slider">
                        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5625 7.31252L3.9375 3.9375L0.5625 0.5625" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <script>
            $(".close-popup-review").click(function(){
              $(".visit-us-review-popup-wrapper").remove();
              $("body").removeClass("review-popup-open");
            });
          </script>
      `);

      new Swiper('.visit-us-review-popup-slider', {   
        loop: false,
        slidesPerView: 'auto', 
        initialSlide: clickedIndex,  
        navigation: {
            nextEl: '.swiper-next-review',
            prevEl: '.swiper-prev-review',
        },        
        freeMode: true,
        loopedSlides: 10, 
        followFinger: true,
        spaceBetween: 13,
        keyboard: {
            enabled: true, 
            onlyInViewport: false, 
        },
        breakpoints: {
            767: {
                spaceBetween: 13
            }
        }
    });
    
});
var width = $(window).width();
 $(".review-image-slider .swiper-wrapper").each(function () {
      var slideC = $(this).find(".swiper-slide").length;

      if (slideC <= 5) {
          $(this).parents(".review-image-slider").find(".swiper-button-prev-jt").hide();
          $(this).parents(".review-image-slider").find(".swiper-button-next-jt").hide();
      }
  });
  $(".city-content-main-wrapper .swiper-wrapper").each(function () {
      var slideCo = $(this).find(".city-content-wrapper").length;

      if (width >= 768 && slideCo <= 5) {
         $(this).parents(".city-content-main-wrapper").find(".swiper-pagination-jt").hide();
          $(this).parents(".city-content-main-wrapper").addClass("swiper-slider-center");
      }

      if (width <= 768 && slideCo <= 3) {
          $(this).parents(".city-content-main-wrapper").find(".swiper-pagination-jt").hide();
          $(this).parents(".city-content-main-wrapper").removeClass("swiper-slider-center");
      }
  });
  $(".location-wrapper-main .swiper-wrapper").each(function () {
      var slideCount = $(this).find(".location-content-wrapper").length;
      if (width >= 768 && slideCount == 1 || width >= 768 && slideCount == 2) {
          $(this).parents(".location-wrapper-main").addClass("swiper-slider-center");
      }
      if (slideCount == 1) {
          $(this).parents(".location-wrapper-main").find(".swiper-paginationjtpl").hide();
      }
  });

  $(".visit-us-section-wrapper").css('opacity','1');
$(".visit-us-section-loaction-inner").css('opacity','1');
 const userAgent = navigator.userAgent.toLowerCase();
  const isLinux = userAgent.includes('linux');
  const isFirefox = userAgent.includes('firefox');
  const isandroid = userAgent.includes('android');
  if(isandroid){
    $(".ios-share-location").css("display", "flex");
  } else if(isLinux || isFirefox){
    $(".location-share-btn").show();
  }else{
    $(".ios-share-location").css("display", "flex");
  }
  
// July 15
// if (window.enableGokwikDrawer === false) {
//   $(document).on('click', '#submit_button', function (e) {
//     e.preventDefault();

//     var $btn = $(this);
//     var $cardWrap = $btn.closest('.card-add-to-cart');
//     var $form = $btn.closest('product-form').find('form');
//     var $spinner = $cardWrap.find('.loading__spinner');
//     var variantId = $form.find('.product-variant-id').val();

//     // Show loader
//     $btn.addClass('visibility-hidden');
//     $spinner.removeClass('hidden');

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {
//             id: variantId,
//             quantity: 1
//         },
//         dataType: 'json',

//         success: function (data) {
//             console.log('Product added:', data);

//             // Get latest cart data
//             $.getJSON('/cart.js', function (cart) {

//                 // Reload cart drawer HTML
//                 $("cart-drawer").load("/cart #CartDrawer", function () {

//                     // Update cart icon bubble
//                     $("#cart-icon-bubble").load("/cart #cart-icon-bubble > *");

//                     // Remove empty state
//                     $("cart-drawer").removeClass("is-empty");
//                     $(".drawer__inner-empty").hide();

//                     // Open cart drawer
//                     var cartDrawer = document.querySelector("cart-drawer");

//                     if (cartDrawer && typeof cartDrawer.open === "function") {
//                         cartDrawer.open();
//                     } else {
//                         $("cart-drawer").addClass("active animate");
//                         $("body").addClass("overflow-hidden");
//                     }
//                 });
//             });
//         },

//         error: function (err) {
//             console.error('Add to cart failed:', err);
//         },

//         complete: function () {
//             $btn.removeClass('visibility-hidden');
//             $spinner.addClass('hidden');
//         }
//     });
// });
// }
// else{
//     document.addEventListener('click', function(e) {
//     const btn = e.target.closest('#submit_button');
//     if (btn && btn.closest('.card-add-to-cart')) {
    
      
//         btn.classList.add('visibility-hidden');
//         const spinner = btn
//             .closest('.card-add-to-cart')
//             .querySelector('.loading__spinner');
//         if (spinner) {
//             spinner.classList.remove('hidden');
//         }
//     }
//   }, true);
// }
// July 15


// MutationObserver to watch for the overlay when it appears in the DOM
const observer = new MutationObserver((mutations, obs) => {
    const overlay = document.getElementById('CartDrawer-Overlay');
    const cursor = document.getElementById('custom-cursor');

    if (overlay && cursor) {
        if (!overlay.dataset.cursorSetup) {
            overlay.addEventListener('mousemove', (e) => {
                cursor.style.opacity = '1';
                cursor.style.left = e.clientX + 'px';
                cursor.style.top = e.clientY + 'px';
            });

            overlay.addEventListener('mouseenter', () => {
                cursor.style.opacity = '1';
            });

            overlay.addEventListener('mouseleave', () => {
                cursor.style.opacity = '0';
            });

            overlay.dataset.cursorSetup = 'true';
        }
        // Optional: Agar aap chahte ho ki ek baar setup hone ke baad observer band ho jaye, 
        // toh niche wali line se comment hata dena:
        // obs.disconnect(); 
    }
});

// Puri body ko observe karna shuru karo changes ke liye
observer.observe(document.body, {
    childList: true,
    subtree: true
});


if (window.enableGokwikDrawer === false) {

if (window.saleTemplate === 'sale_template') {


  window.saleCartSyncInProgress = false;

  function showSaleViewCartMessage() {

    var stickyContent =
      document.getElementById('sticky_content');

    if (!stickyContent) return;

    stickyContent.style.display = 'flex';

    clearTimeout(window._stickyHideTimer);

    window._stickyHideTimer = setTimeout(function () {

      stickyContent.style.display = 'none';

    }, 3000);
  }


  function updateSaleCartBubble(cart) {

    if (cart) {

      setSaleCartBubble(cart);

      return;
    }


    fetch('/cart.js', {
      cache: 'no-store'
    })
      .then(function (response) {

        return response.json();

      })
      .then(function (cart) {

        setSaleCartBubble(cart);

      })
      .catch(function (error) {

        console.error(
          'Cart bubble update error:',
          error
        );

      });
  }


  function setSaleCartBubble(cart) {
    // Multiple common selectors try karte hain taaki theme ke hisaab se miss na ho
    var cartBubbles = document.querySelectorAll(
      '.cart-count-bubble, #cart-icon-bubble .cart-count, .cart-count'
    );

    if (!cartBubbles.length) return;

    cartBubbles.forEach(function(cartBubble) {
      var count = cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0;

      if (count > 0) {
        cartBubble.textContent = count;
        cartBubble.classList.remove('hide');
        cartBubble.style.display = 'flex'; // Agar theme mein display none/flex ka chakkar ho
      } else {
        // Agar cart empty ho gaya toh hide kar do
         if (!cartBubble) {
          cartBubble = document.createElement('div');
          cartBubble.className = 'cart-count-bubble';
          cartIcon.appendChild(cartBubble); // Isko icon ke andar add kar do
        }
        
        // Count update karo aur show karo
        cartBubble.textContent = cartCount;
        cartBubble.classList.add('hide');
      }
    });
  }
  function findSaleCardByVariant(variantId) {
    var $foundSelectors = $();

    $('.card-quantity-selector').each(function () {
      var $selector = $(this);
      var selectorVariantId = String($selector.attr('data-variant-id'));

      if (selectorVariantId === String(variantId)) {
        $foundSelectors = $foundSelectors.add($selector);
      }
    });

    return $foundSelectors;
  }

  function setSaleCardState(variantId, quantity, cartKey) {
    var $selectors = findSaleCardByVariant(variantId);

    if (!$selectors.length) {
      return;
    }

    $selectors.each(function() {
      var $selector = $(this);
      var $form = $selector.closest('form');
      var $btn = $form.find('.card-add-to-cart');
      var $input = $selector.find('.qty-input');

      if (quantity > 0) {
        $input.val(quantity);
        $selector.removeClass('hidden');
        $btn.addClass('hidden');

        if (cartKey) {
          $btn.attr('data-cart-key', cartKey);
        }
      } else {
        $selector.addClass('hidden');
        $btn.removeClass('hidden');
        $input.val(1);
        $btn.removeAttr('data-cart-key');
      }
    });
  }

  function syncSaleCardsWithCart(cart) {

    if (!cart || !cart.items) return;


    $('.card-quantity-selector').each(
      function () {

        var $selector =
          $(this);


        var variantId =
          String(
            $selector.attr(
              'data-variant-id'
            )
          );


        if (!variantId) return;


        var cartItem =
          cart.items.find(
            function (item) {

              return String(
                item.variant_id
              ) === variantId;

            }
          );

        if (cartItem) {

          setSaleCardState(
            variantId,
            cartItem.quantity,
            cartItem.key
          );

        }

        else {

          setSaleCardState(
            variantId,
            0,
            null
          );

        }

      }
    );
  }


  function syncSaleCards() {

    return fetch('/cart.js', {
      cache: 'no-store'
    })

      .then(function (response) {

        return response.json();

      })

      .then(function (cart) {

        syncSaleCardsWithCart(
          cart
        );

        updateSaleCartBubble(
          cart
        );

        return cart;

      })

      .catch(function (error) {

        console.error(
          'Sale card sync error:',
          error
        );

        throw error;

      });
  }
  function setupSaleCartCursor() {

    var overlay =
      document.getElementById(
        'CartDrawer-Overlay'
      );

    var cursor =
      document.getElementById(
        'custom-cursor'
      );


    if (
      !overlay ||
      !cursor
    ) {

      return;

    }


    if (
      overlay.dataset.cursorSetup
    ) {

      return;

    }


    overlay.addEventListener(
      'mousemove',
      function (e) {

        cursor.style.opacity = '1';

        cursor.style.left =
          e.clientX + 'px';

        cursor.style.top =
          e.clientY + 'px';

      }
    );


    overlay.addEventListener(
      'mouseenter',
      function () {

        cursor.style.opacity = '1';

      }
    );


    overlay.addEventListener(
      'mouseleave',
      function () {

        cursor.style.opacity = '0';

      }
    );


    overlay.dataset.cursorSetup =
      'true';
  }

  $(document).on(
    'click.saleQuickAdd',
    '.card-add-to-cart',
    function (e) {

      e.preventDefault();
      e.stopPropagation();


      var $btn =
        $(this);


      // Already loading?
      if (
        $btn.data(
          'sale-loading'
        )
      ) {

        return;

      }


      var $text =
        $btn.find(
          '#submit_button'
        );


      var $spinner =
        $btn.find(
          '.loading__spinner'
        );


      var $form =
        $btn
          .closest(
            'product-form'
          )
          .find(
            'form'
          );


      var variantId =
        $form
          .find(
            '.product-variant-id'
          )
          .val();


      var $quantitySelector =
        $form.find(
          '.card-quantity-selector'
        );


      var $qtyInput =
        $quantitySelector.find(
          '.qty-input'
        );


      if (!variantId) {

        console.error(
          'Variant ID not found'
        );

        return;

      }


      console.log(
        'SALE CARD QUICK ADD:',
        variantId
      );


      $btn.data(
        'sale-loading',
        true
      );

      $text.addClass(
        'visibility-hidden'
      );


      if ($spinner.length) {

        $spinner.removeClass(
          'hidden'
        );

      }

      $.ajax({

        type: 'POST',

        url: '/cart/add.js',

        data: {

          id: variantId,

          quantity: 1

        },

        dataType: 'json',


        success: function (data) {

          console.log(
            'SALE PRODUCT ADDED:',
            data
          );


          fetch('/cart.js', {
            cache: 'no-store'
          })

            .then(function (response) {

              return response.json();

            })

            .then(function (cart) {


              var cartItem =
                cart.items.find(
                  function (item) {

                    return String(
                      item.variant_id
                    ) === String(
                      variantId
                    );

                  }
                );


              var quantity =
                cartItem
                  ? cartItem.quantity
                  : 1;


              var cartKey =
                cartItem
                  ? cartItem.key
                  : null;

              $qtyInput.val(
                quantity
              );


              if (cartKey) {

                $btn.attr(
                  'data-cart-key',
                  cartKey
                );

              }



              $btn.addClass(
                'hidden'
              );

              $quantitySelector.removeClass(
                'hidden'
              );

              $text.removeClass(
                'visibility-hidden'
              );


              if ($spinner.length) {

                $spinner.addClass(
                  'hidden'
                );

              }


              $btn.removeData(
                'sale-loading'
              );

              showSaleViewCartMessage();

              updateSaleCartBubble(
                cart
              );

              setTimeout(
                function () {

                  setupSaleCartCursor();

                },
                300
              );


              var cartType =
                window.themeCartType;
              if (
                cartType === 'page'
              ) {

                window.location.href =
                  (
                    window.Shopify &&
                    window.Shopify.routes &&
                    window.Shopify.routes.root

                      ? window.Shopify.routes.root

                      : '/'
                  ) + 'cart';


                return;

              }

              if (
                cartType ===
                'notification'
              ) {

                $.get(
                  `${window.location.pathname}?sections=cart-notification`,
                  function (
                    sectionData
                  ) {

                    var parsed =
                      typeof sectionData ===
                      'string'

                        ? JSON.parse(
                            sectionData
                          )

                        : sectionData;


                    var newHTML =
                      parsed[
                        'cart-notification'
                      ];


                    if (newHTML) {

                      var $newInner =
                        $(newHTML)
                          .find(
                            'cart-notification'
                          )
                          .first();


                      var $current =
                        $('cart-notification');


                      if (
                        $newInner.length &&
                        $current.length
                      ) {

                        $current.html(
                          $newInner.html()
                        );

                      }

                    }


                    var notif =
                      document.querySelector(
                        'cart-notification'
                      );


                    if (
                      notif &&
                      typeof notif.open ===
                      'function'
                    ) {

                      notif.open();

                    }

                    else {

                      $('#cart-icon-bubble')
                        .load(
                          '/cart #cart-icon-bubble > *'
                        );

                    }

                  }
                );


                return;

              }

              refreshSaleCartDrawer(
                false
              );

            })


            .catch(function (error) {

              console.error(
                'Cart fetch after add failed:',
                error
              );


              resetSaleQuickAdd(
                $btn,
                $text,
                $spinner
              );

            });

        },


        error: function (err) {

          console.error(
            'Add to cart failed:',
            err
          );


          resetSaleQuickAdd(
            $btn,
            $text,
            $spinner
          );

        }

      });

    }
  );

  function resetSaleQuickAdd(
    $btn,
    $text,
    $spinner
  ) {

    $text.removeClass(
      'visibility-hidden'
    );


    if ($spinner.length) {

      $spinner.addClass(
        'hidden'
      );

    }


    $btn.removeData(
      'sale-loading'
    );

  }

  $(document).on(
    'click.saleCardPlus',
    '.card-quantity-selector .qty-plus',
    function (e) {

      e.preventDefault();
      e.stopPropagation();


      var $plus =
        $(this);


      var $selector =
        $plus.closest(
          '.card-quantity-selector'
        );


      var $form =
        $selector.closest(
          'form'
        );


      var $btn =
        $form.find(
          '.card-add-to-cart'
        );


      var $input =
        $selector.find(
          '.qty-input'
        );


      var currentQty =
        parseInt(
          $input.val(),
          10
        ) || 1;


      var newQty =
        currentQty + 1;


      var cartKey =
        $btn.attr(
          'data-cart-key'
        );


      if (!cartKey) {

        console.error(
          'Cart key not found for plus'
        );

        syncSaleCards();

        return;

      }


      updateSaleCardQuantity(
        $btn,
        $selector,
        $input,
        cartKey,
        currentQty,
        newQty,
        true
      );

    }
  );


  $(document).on(
    'click.saleCardMinus',
    '.card-quantity-selector .qty-minus',
    function (e) {

      e.preventDefault();
      e.stopPropagation();


      var $minus =
        $(this);


      var $selector =
        $minus.closest(
          '.card-quantity-selector'
        );


      var $form =
        $selector.closest(
          'form'
        );


      var $btn =
        $form.find(
          '.card-add-to-cart'
        );


      var $input =
        $selector.find(
          '.qty-input'
        );


      var currentQty =
        parseInt(
          $input.val(),
          10
        ) || 1;


      var newQty =
        currentQty - 1;


      var cartKey =
        $btn.attr(
          'data-cart-key'
        );


      if (!cartKey) {

        console.error(
          'Cart key not found for minus'
        );

        syncSaleCards();

        return;

      }


      updateSaleCardQuantity(
        $btn,
        $selector,
        $input,
        cartKey,
        currentQty,
        newQty,
        false
      );

    }
  );

  function updateSaleCardQuantity(
    $btn,
    $selector,
    $input,
    cartKey,
    currentQty,
    newQty,
    showMessage
  ) {


    if (
      $selector.data(
        'updating'
      )
    ) {

      return;

    }


    $selector.data(
      'updating',
      true
    );


    $.ajax({

      type: 'POST',

      url: '/cart/change.js',

      data: {

        id: cartKey,

        quantity: Math.max(
          0,
          newQty
        )

      },

      dataType: 'json',


      success: function (cart) {

        console.log(
          'CARD QUANTITY UPDATED:',
          newQty
        );



        syncSaleCardsWithCart(
          cart
        );


        updateSaleCartBubble(
          cart
        );

        if (
          showMessage &&
          newQty > currentQty
        ) {

          showSaleViewCartMessage();

        }

        refreshSaleCartDrawer(
          false
        );

      },


      error: function (err) {

        console.error(
          'Quantity update failed:',
          err
        );


        syncSaleCards();

      },


      complete: function () {

        $selector.removeData(
          'updating'
        );

      }

    });

  }

  function refreshSaleCartDrawer(
    openDrawer
  ) {

    $.getJSON(
      '/cart.js',
      function (cart) {


        $('cart-drawer').load(
          '/cart #CartDrawer',
          function (
            response,
            status,
            xhr
          ) {


            console.log(
              'Cart drawer refreshed:',
              status
            );

            $('#cart-icon-bubble').load(
              '/cart #cart-icon-bubble > *'
            );

            // Check if cart is empty
            if (cart.item_count === 0) {
              $('cart-drawer').addClass('is-empty');
              $('.drawer__inner-empty').show();
            } else {
              $('cart-drawer').removeClass('is-empty');
              $('.drawer__inner-empty').hide();
            }

            syncSaleCardsWithCart(
              cart
            );


            updateSaleCartBubble(
              cart
            );


            setupSaleCartCursor();

            var cartDrawer =
              document.querySelector(
                'cart-drawer'
              );


            if (
              cartDrawer &&
              typeof cartDrawer.open ===
              'function'
            ) {

              var viewCartBtn =
                document.getElementById(
                  'view_cart'
                );


              if (
                viewCartBtn &&
                !viewCartBtn.dataset.bound
              ) {

                viewCartBtn.addEventListener(
                  'click',
                  function () {

                    cartDrawer.open();

                  }
                );


                viewCartBtn.dataset.bound =
                  'true';

              }

              if (openDrawer) {

                cartDrawer.open();

              }

            }

            else {

              $('cart-drawer')
                .addClass(
                  'active animate'
                );


              $('body')
                .addClass(
                  'overflow-hidden'
                );

            }

          }
        );

      }
    );

  }

  $(document).on(
    'click.saleDrawerQuantity',
    '#CartDrawer .quantity__button, cart-drawer .quantity__button',
    function () {

      console.log(
        'DRAWER QUANTITY BUTTON CLICKED'
      );


      var $clicked =
        $(this);

      var isPlus =
        $clicked.hasClass(
          'plus'
        ) ||
        $clicked.attr(
          'name'
        ) === 'plus' ||
        $clicked.find(
          '.icon-plus'
        ).length > 0;


      var isMinus =
        $clicked.hasClass(
          'minus'
        ) ||
        $clicked.attr(
          'name'
        ) === 'minus' ||
        $clicked.find(
          '.icon-minus'
        ).length > 0;
      if (
        $clicked.hasClass(
          'quantity__button--plus'
        )
      ) {

        isPlus = true;

      }


      if (
        $clicked.hasClass(
          'quantity__button--minus'
        )
      ) {

        isMinus = true;

      }

      fetch('/cart.js', {
        cache: 'no-store'
      })

        .then(function (response) {

          return response.json();

        })

        .then(function (oldCart) {

          waitForSaleCartUpdate(
            oldCart,
            0,
            isPlus
          );

        })

        .catch(function (error) {

          console.error(
            'Drawer old cart error:',
            error
          );

        });

    }
  );

  function waitForSaleCartUpdate(
    oldCart,
    attempt,
    clickedWasPlus
  ) {

    if (
      attempt >= 12
    ) {

      syncSaleCards();

      return;

    }


    setTimeout(
      function () {

        fetch('/cart.js', {
          cache: 'no-store'
        })

          .then(function (response) {

            return response.json();

          })

          .then(function (newCart) {


            var changed =
              saleCartChanged(
                oldCart,
                newCart
              );


            if (changed) {
              syncSaleCardsWithCart(
                newCart
              );


              updateSaleCartBubble(
                newCart
              );

              if (
                clickedWasPlus &&
                saleCartHasQuantityIncrease(
                  oldCart,
                  newCart
                )
              ) {

                showSaleViewCartMessage();

              }


              return;

            }

            waitForSaleCartUpdate(
              oldCart,
              attempt + 1,
              clickedWasPlus
            );

          })

          .catch(function (error) {

            console.error(
              'Drawer cart sync error:',
              error
            );


            waitForSaleCartUpdate(
              oldCart,
              attempt + 1,
              clickedWasPlus
            );

          });

      },
      250
    );

  }

  function saleCartChanged(
    oldCart,
    newCart
  ) {

    if (
      oldCart.item_count !==
      newCart.item_count
    ) {

      return true;

    }


    if (
      oldCart.items.length !==
      newCart.items.length
    ) {

      return true;

    }


    for (
      var i = 0;
      i < newCart.items.length;
      i++
    ) {

      var newItem =
        newCart.items[i];


      var oldItem =
        oldCart.items.find(
          function (item) {

            return item.key ===
              newItem.key;

          }
        );


      if (!oldItem) {

        return true;

      }


      if (
        oldItem.quantity !==
        newItem.quantity
      ) {

        return true;

      }

    }


    return false;

  }

  function saleCartHasQuantityIncrease(
    oldCart,
    newCart
  ) {

    var increased =
      false;


    newCart.items.forEach(
      function (newItem) {

        var oldItem =
          oldCart.items.find(
            function (item) {

              return item.key ===
                newItem.key;

            }
          );


        if (
          oldItem &&
          newItem.quantity >
          oldItem.quantity
        ) {

          increased = true;

        }

      }
    );


    return increased;

  }

  $(document).on(
    'click.saleDrawerRemove',
    '#CartDrawer .cart-remove-button, cart-drawer .cart-remove-button',
    function () {

      console.log(
        'DRAWER REMOVE CLICKED'
      );

      fetch('/cart.js', {
        cache: 'no-store'
      })

        .then(function (response) {

          return response.json();

        })

        .then(function (oldCart) {

          waitForSaleRemove(
            oldCart,
            0
          );

        })

        .catch(function (error) {

          console.error(
            'Remove snapshot error:',
            error
          );

        });

    }
  );
  $(document).on(
    'click.saleDrawerRemove',
    '#CartDrawer cart-remove-button, cart-drawer cart-remove-button',
    function () {

      console.log(
        'DRAWER REMOVE CLICKED'
      );

      // Thoda delay dekar cart fetch karein taaki Shopify backend par item delete ho chuka ho
      setTimeout(function () {
        syncSaleCards();
      }, 500);

      // Extra safety ke liye polling bhi run kar dete hain
      fetch('/cart.js', {
        cache: 'no-store'
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (oldCart) {
          waitForSaleRemove(oldCart, 0);
        })
        .catch(function (error) {
          console.error('Remove snapshot error:', error);
        });

    }
  );

  function waitForSaleRemove(
    oldCart,
    attempt
  ) {

    if (
      attempt >= 12
    ) {

      syncSaleCards();

      return;

    }


    setTimeout(
      function () {

        fetch('/cart.js', {
          cache: 'no-store'
        })

          .then(function (response) {

            return response.json();

          })

          .then(function (newCart) {

            // Chahe change detect ho ya na ho, agar items kam hue hain toh sync sale cards run kar do
            if (newCart.items.length < oldCart.items.length || saleCartChanged(oldCart, newCart)) {

              syncSaleCardsWithCart(newCart);
              updateSaleCartBubble(newCart);
              
              // Saare cards ko ek baar fresh cart ke sath re-sync kar lo taaki jo remove hua hai wo hide ho jaye
              syncSaleCards();

              return;

            }

            waitForSaleRemove(
              oldCart,
              attempt + 1
            );

          })

          .catch(function (error) {

            console.error(
              'Remove polling error:',
              error
            );


            waitForSaleRemove(
              oldCart,
              attempt + 1
            );

          });

      },
      250
    );

  }

  $(document).on(
    'change.saleDrawerInput',
    '#CartDrawer input[name="updates[]"], cart-drawer input[name="updates[]"]',
    function () {

      var $input =
        $(this);


      fetch('/cart.js', {
        cache: 'no-store'
      })

        .then(function (response) {

          return response.json();

        })

        .then(function (oldCart) {


          setTimeout(
            function () {

              fetch('/cart.js', {
                cache: 'no-store'
              })

                .then(function (response) {

                  return response.json();

                })

                .then(function (newCart) {


                  syncSaleCardsWithCart(
                    newCart
                  );


                  updateSaleCartBubble(
                    newCart
                  );

                  if (
                    saleCartHasQuantityIncrease(
                      oldCart,
                      newCart
                    )
                  ) {

                    showSaleViewCartMessage();

                  }

                });

            },
            500
          );

        });

    }
  );

  document.addEventListener(
    'cart:updated',
    function () {

      setTimeout(
        function () {

          syncSaleCards();

          updateSaleCartBubble();

        },
        300
      );

    }
  );

  $(document).ready(
    function () {

      syncSaleCards();

      setupSaleCartCursor();

    }
  );

}
else{
  $(document).on('click', '#submit_button', function (e) {
    e.preventDefault();

    var $btn = $(this);
    var $cardWrap = $btn.closest('.card-add-to-cart');
    var $form = $btn.closest('product-form').find('form');
    var $spinner = $cardWrap.find('.loading__spinner');
    var variantId = $form.find('.product-variant-id').val();

    // Show loader
    $btn.addClass('visibility-hidden');
    $spinner.removeClass('hidden');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: variantId,
            quantity: 1
        },
        dataType: 'json',

        success: function (data) {
           // console.log('Product added (jQuery Grid Button):', data);
             setTimeout(function () {
        const overlay = document.getElementById('CartDrawer-Overlay');
        const cursor = document.getElementById('custom-cursor');

        if (overlay && cursor) {
            // To prevent adding multiple event listeners
            if (!overlay.dataset.cursorSetup) {
                overlay.addEventListener('mousemove', (e) => {
                    cursor.style.opacity = '1';
                    cursor.style.left = e.clientX + 'px';
                    cursor.style.top = e.clientY + 'px';
                });

                overlay.addEventListener('mouseenter', () => {
                    cursor.style.opacity = '1';
                });

                overlay.addEventListener('mouseleave', () => {
                    cursor.style.opacity = '0';
                });

                // Mark as initialized
                overlay.dataset.cursorSetup = 'true';
            }
        } else {
          //  console.warn("Overlay or custom cursor element not found.");
        }
         let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
              // console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1300);

            var cartType = window.themeCartType;

            // ---- PAGE TYPE ----
            if (cartType === 'page') {
                window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                    ? window.Shopify.routes.root
                    : '/') + 'cart';
                return;
            }

            // ---- NOTIFICATION TYPE ----
            if (cartType === 'notification') {
                $.get(`${window.location.pathname}?sections=cart-notification`, function (sectionData) {
                   // console.log('--- JQUERY NOTIFICATION RESPONSE DATA ---', sectionData);
                    var parsed = typeof sectionData === 'string' ? JSON.parse(sectionData) : sectionData;
                    var newHTML = parsed['cart-notification'];
                   // console.log('--- EXTRACTED NOTIFICATION HTML ---', newHTML);
                    if (newHTML) {
                        var $newInner = $(newHTML).find('cart-notification').first();
                        var $current = $('cart-notification');
                        if ($newInner.length && $current.length) {
                           // console.log('Replacing Notification DOM Content...');
                            $current.html($newInner.html());
                        }
                    }
                    var notif = document.querySelector('cart-notification');
                    if (notif && typeof notif.open === 'function') {
                        notif.open();
                    } else {
                        $('#cart-icon-bubble').load('/cart #cart-icon-bubble > *');
                    }
                });
                return;
            }
            $.getJSON('/cart.js', function (cart) {
             //   console.log('--- INITIATING JQUERY DRAWER DOM LOAD ---');
                $("cart-drawer").load("/cart #CartDrawer", function (response, status, xhr) {
                    // console.log('--- JQUERY DRAWER LOAD COMPLETE --- Status:', status);
                    // console.log('Loaded Drawer innerHTML Structure:', document.querySelector("cart-drawer")?.innerHTML);
                    
                    $("#cart-icon-bubble").load("/cart #cart-icon-bubble > *");
                    $("cart-drawer").removeClass("is-empty");
                    $(".drawer__inner-empty").hide();

                    var cartDrawer = document.querySelector("cart-drawer");
                    if (cartDrawer && typeof cartDrawer.open === "function") {
                        cartDrawer.open();
                    } else {
                        $("cart-drawer").addClass("active animate");
                        $("body").addClass("overflow-hidden");
                    }
                });
            });
        },

        error: function (err) {
            console.error('Add to cart failed:', err);
        },

        complete: function () {
            $btn.removeClass('visibility-hidden');
            $spinner.addClass('hidden');
        }
    });
  });
}
 }
else{
    document.addEventListener('click', function(e) {
    const btn = e.target.closest('#submit_button');
    if (btn && btn.closest('.card-add-to-cart')) {
        btn.classList.add('visibility-hidden');
        const spinner = btn
            .closest('.card-add-to-cart')
            .querySelector('.loading__spinner');
        if (spinner) {
            spinner.classList.remove('hidden');
        }
    }
  }, true);
}
});



function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;
     // console.log("Current Cart Count: " + cartCount);
 
      // Cart icon container dhundho
      const cartIcon = document.getElementById('cart-icon-bubble');
      
      if (!cartIcon) {
       // console.error("Cart icon (#cart-icon-bubble) nahi mila page par!");
        return;
      }

      // Check karo ki uske andar bubble hai ya nahi
      let cartBubble = cartIcon.querySelector('.cart-count-bubble');

      if (cartCount > 0) {
        // Agar items hain par div nahi hai, toh naya div banao!
        if (!cartBubble) {
          cartBubble = document.createElement('div');
          cartBubble.className = 'cart-count-bubble';
          cartIcon.appendChild(cartBubble); // Isko icon ke andar add kar do
        }
        
        // Count update karo aur show karo
        cartBubble.textContent = cartCount;
        cartBubble.style.display = 'flex'; 
        cartBubble.classList.remove('hide');
      } else {
        // Agar cart empty ho gaya toh hide kar do
         if (!cartBubble) {
          cartBubble = document.createElement('div');
          cartBubble.className = 'cart-count-bubble';
          cartIcon.appendChild(cartBubble); // Isko icon ke andar add kar do
        }
        
        // Count update karo aur show karo
        cartBubble.textContent = cartCount;
        cartBubble.classList.add('hide');
      }
    })
    .catch(error => console.error('Cart API error:', error));
}
// function initRecommendationSlider() {
//   const slider = document.querySelector('.cart-drawer-recommendation');
  
//   if (!slider) return;
//   if (typeof Swiper === 'undefined') return;

//   // AGAR SWIPER ALREADY INITIALIZED HAI TOH KUCH MAT KARO (Scroll issue fix)
//   if (slider.swiper || slider.classList.contains('swiper-initialized')) {
//     return;
//   }

//   let options = {
//     spaceBetween: 10,
//    slidesPerView: 2.5,
//     centeredSlides: false,
//     loop: false,
//     breakpoints: {
//               768: {
//                   slidesPerView: 2
//               }
//           },
//   };

//   if (slider.dataset.swiper) {
//     try {
//       options = { ...options, ...JSON.parse(slider.dataset.swiper) };
//     } catch (e) {
//       // JSON error handling
//     }
//   }
  
//   options.scrollbar = {
//     el: slider.querySelector('.swiper-scrollbar'),
//     draggable: true,
//     hide: false
//   };

//   // Fresh swiper initiation
//   new Swiper(slider, options);
// }

function initRecommendationSlider() {
  const slider = document.querySelector('.cart-drawer-recommendation');
  
  if (!slider) return;
  
  // Review widgets ko trigger karo taaki total reviews ki jagah stars sahi se render ho jayein
  triggerReviewApps();

  if (typeof Swiper === 'undefined') return;

  // Agar Swiper already initialized hai toh dobara mat karo
  if (slider.swiper || slider.classList.contains('swiper-initialized')) {
    return;
  }

  let options = {
    spaceBetween: 10,
    slidesPerView: 2.5,
    centeredSlides: false,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    }
  };

  if (slider.dataset.swiper) {
    try {
      options = { ...options, ...JSON.parse(slider.dataset.swiper) };
    } catch (e) {
      // JSON error handling
    }
  }
  
  options.scrollbar = {
    el: slider.querySelector('.swiper-scrollbar'),
    draggable: true,
    hide: false
  };

  // Fresh swiper initiation
  new Swiper(slider, options);
}

// Review Apps ko re-trigger karne ka function (Judge.me, Loox, Rivyo, etc.)
function triggerReviewApps() {
  setTimeout(function() {
    // 1. Judge.me fix
    if (typeof jdgm !== 'undefined' && typeof jdgm.customizeBadges === 'function') {
      jdgm.customizeBadges();
    }
    // 2. Alternate Judge.me trigger mechanism
    if (window.jdgm && typeof window.jdgm.loadBadges === 'function') {
      window.jdgm.loadBadges();
    }
    // 3. General Shopify review widgets event dispatching
    document.dispatchEvent(new CustomEvent('jdgm:refresh-badges'));
  }, 200);
}

// Initial load
document.addEventListener('DOMContentLoaded', function(){
  initRecommendationSlider();
});

// Dawn cart drawer observer
const cartDrawer = document.querySelector('cart-drawer');

if(cartDrawer){
  const cartDrawerObserver = new MutationObserver(function(mutations){
    let shouldInit = false;

    mutations.forEach(function(mutation){
      if(mutation.type === 'childList' && mutation.addedNodes.length > 0){
        if(cartDrawer.querySelector('.cart-drawer-recommendation')){
          shouldInit = true;
        }
      }
    });

    if(shouldInit){
      setTimeout(function(){
        initRecommendationSlider();
      }, 300);
    }
  });

  cartDrawerObserver.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// Cart drawer open click
document.addEventListener('click', function(e){
  if(
    e.target.closest('.cart-icon-bubble') ||
    e.target.closest('[href="/cart"]') ||
    e.target.closest('cart-drawer')
  ){
    setTimeout(function(){
      initRecommendationSlider();
    }, 500);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  initRecommendationSlider();
});
document.addEventListener("DOMContentLoaded", function () {
  console.log(" Order Note JS Loaded");
  function getElements() {
    return {
      popup: document.querySelector(".order-note-popup"),
      overlay: document.querySelector(".note-overlay"),
      textarea: document.querySelector("#orderNoteInput"),
      savedBox: document.querySelector(".saved-order-note"),
      addBox: document.querySelector(".add-order-note"),
      savedText: document.querySelector("#savedNoteText")
    };
  }

  function openPopup() {
    const { popup, overlay } = getElements();
    console.log("Open Popup Clicked");
    console.log("Popup:", popup);
    console.log("Overlay:", overlay);

    if (!popup || !overlay) {
      console.error("Popup or Overlay not found");
      return;
    }
    popup.classList.add("active");
    overlay.classList.add("active");
  }

  function closePopup() {
    const { popup, overlay } = getElements();

    console.log("Close Popup");
    popup?.classList.remove("active");
    overlay?.classList.remove("active");
  }

  document.addEventListener("click", function (e) {

    if (e.target.closest("#openOrderNote")) {
      console.log("Open Note Button Clicked");
      openPopup();
      return;
    }
    if (e.target.closest("#closeOrderNote")) {
      console.log("Close Button Clicked");
      closePopup();
      return;
    }
    if (e.target.closest(".note-overlay")) {
      console.log("Overlay Clicked");
      closePopup();
      return;
    }
    if (e.target.closest("#editOrderNote")) {
      console.log("Edit Clicked");
      const { textarea, savedText } = getElements();
      console.log("Textarea:", textarea);
      console.log("Saved Text:", savedText);

      if (textarea && savedText) {
        textarea.value = savedText.textContent.trim();
      }
      openPopup();
      return;
    }
    if (e.target.closest("#saveOrderNote")) {
      console.log("Save Button Clicked");
      const {
        textarea,
        savedText,
        savedBox,
        addBox
      } = getElements();
      let note = textarea.value.trim();
      console.log("Note:", note);
      if (!note) {
        console.warn("Note Empty");
        textarea.focus();
        return;
      }
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          note: note
        })
      })
      .then(res => {
        console.log("Fetch Response:", res);
        return res.json();
      })
      .then(data => {

        console.log("Cart Updated:", data);

        savedText.textContent = note;
        savedBox.classList.remove("hidden");
        addBox.classList.add("hidden");

        closePopup();
      })
      .catch(err => {
        console.error("Save Error:", err);
      });
      return;
    }

    if (e.target.closest("#deleteOrderNote")) {
      console.log("Delete Clicked");
      const {
        textarea,
        savedText,
        savedBox,
        addBox
      } = getElements();
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          note: ""
        })
      })
      .then(res => {
        console.log("Delete Response:", res);
        return res.json();
      })
      .then(data => {
        console.log("Note Deleted:", data);
        textarea.value = "";
        savedText.textContent = "";
        savedBox.classList.add("hidden");
        addBox.classList.remove("hidden");

        closePopup();
      })
      .catch(err => {
        console.error("Delete Error:", err);
      });
    }
  });
});

class CartRecommendationObserver {
  constructor() {
    this.initObserver();
  }

  initObserver() {
    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        // Sirf childList check karein, attributes nahi (jo swiper drag par badalte hain)
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              // Check karein ki kya pure element replace hua hai ya naya cart load hua hai
              if (node.classList?.contains('cart-drawer-recommendation') || node.querySelector?.('.cart-drawer-recommendation')) {
                shouldReinit = true;
              }
            }
          });
        }
      });

      if (shouldReinit) {
        // Agar slider already sahi chal raha hai, toh drag ke beech mein distrub na karein
        const slider = document.querySelector('.cart-drawer-recommendation');
        if (slider && slider.swiper) {
           // Agar slider active hai toh dobara init karne ki zaroorat nahi hai
           return; 
        }

        setTimeout(() => {
          initRecommendationSlider();
        }, 100);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}
new CartRecommendationObserver();
const nativeFetch = window.fetch;
window.fetch = async function(...args) {
  const response = await nativeFetch(...args);
  const url = args[0] ;
  
  if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
    setTimeout(() => {
      initRecommendationSlider();
    }, 400); 
  }
  return response;
};
if (window.enableGokwikDrawer === false) {
  document.addEventListener('click', function (e) {
    const pdpBtn = e.target.closest('.product-form__submit');
    if (pdpBtn && pdpBtn.closest('.product-form__buttons')) {
      if (pdpBtn.hasAttribute('disabled')) return;
      
      e.preventDefault();
      const form = pdpBtn.closest('form');
      if (!form) return;

      const $addToCart = $(pdpBtn);
      const variantInput = form.querySelector('input[name="id"], .product-variant-id');
      const currentVariantId = variantInput ? variantInput.value : null;
      if (!currentVariantId) return;

      // 1. UI Loading State
      const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
      textSpans.forEach(span => span.style.setProperty('visibility', 'hidden', 'important'));
      const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
      if (pdpSpinner) pdpSpinner.classList.remove('hidden');

      const formData = new FormData(form);
      formData.set('id', currentVariantId);

      // 2. Post to Shopify Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw new Error(err.description || 'Failed to add item') });
        }
        return res.json();
      })
      .then(data => {
       // console.log('Product added (PDP Native Fetch):', data);
        $('body').trigger('added.ajaxProduct', $addToCart);
         setTimeout(function () {
        const overlay = document.getElementById('CartDrawer-Overlay');
        const cursor = document.getElementById('custom-cursor');

        if (overlay && cursor) {
            if (!overlay.dataset.cursorSetup) {
                overlay.addEventListener('mousemove', (e) => {
                    cursor.style.opacity = '1';
                    cursor.style.left = e.clientX + 'px';
                    cursor.style.top = e.clientY + 'px';
                });

                overlay.addEventListener('mouseenter', () => {
                    cursor.style.opacity = '1';
                });

                overlay.addEventListener('mouseleave', () => {
                    cursor.style.opacity = '0';
                });

                overlay.dataset.cursorSetup = 'true';
            }
        } else {
          //  console.warn("Overlay or custom cursor element not found.");
        }
         let cartCount = null;
          fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              cartCount = cart.item_count;
             // console.log("cartCount"+cartCount);
        
              const cartBubble = document.querySelector('.cart-count-bubble');
        
              if (cartCount > 0) {
                cartBubble.textContent = cartCount;
                cartBubble.classList.remove('hide');
              } else {
                cartBubble.classList.add('hide');
              }
            })
            .catch(error => console.error('Cart update error:', error));
    }, 1300);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));

        const cartType = window.themeCartType;

        // Route A: Cart Page Redirect
        if (cartType === 'page') {
          const rootUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
          window.location.href = rootUrl + 'cart';
          return;
        }

        // Route B: Notification Popup
        if (cartType === 'notification') {
          return fetch(`${window.location.pathname}?sections=cart-notification`)
            .then(res => res.json())
            .then(sectionData => {
            //  console.log('--- NATIVE FETCH NOTIFICATION RAW SECTIONS DATA ---', sectionData);
              const html = sectionData['cart-notification'];
             // console.log('--- NATIVE FETCH NOTIFICATION HTML ---', html);

              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              const newNotification = doc.querySelector('cart-notification') || doc.querySelector('.cart-notification');
              const currentNotification = document.querySelector('cart-notification') || document.querySelector('.cart-notification');

              if (newNotification && currentNotification) {
               // console.log('Replacing Notification contents with innerHTML logic...');
                currentNotification.innerHTML = newNotification.innerHTML;
                currentNotification.className = newNotification.className;
              }

              const notification = document.querySelector('cart-notification') || document.querySelector('.cart-notification');
              if (notification && typeof notification.open === 'function') {
                notification.open();
              }
              
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function(){
             updateCartCount();
            },500);
             
              if (typeof theme !== 'undefined' && theme.cart) theme.cart.render(); 
            });
        }

        // Route C: Slide-out Drawer (Default fallback)
        const sectionId = 'cart-drawer'; 
        
        return fetch(`${window.location.pathname}?sections=${sectionId}`)
          .then(res => res.json())
          .then(drawerData => {
           // console.log(`--- NATIVE FETCH DRAWER RAW SECTION DATA (${sectionId}) ---`, drawerData);
            const drawerHTML = drawerData[sectionId];
           // console.log('--- NATIVE FETCH DRAWER RAW HTML ---', drawerHTML);

            if (!drawerHTML) {
             // console.error(`Could not find section HTML for key: ${sectionId}. Verify this file exists in your /sections folder.`);
              return;
            }

            const parser = new DOMParser();
            const doc = parser.parseFromString(drawerHTML, 'text/html');
            
            const newDrawer = doc.querySelector('cart-drawer') || doc.querySelector('.cart-drawer') || doc.querySelector('#CartDrawer');
            const currentDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer') || document.querySelector('#CartDrawer');

            // console.log('Old Drawer content before replacement:', currentDrawer?.innerHTML);
            // console.log('New Drawer content to be injected:', newDrawer?.innerHTML);

            if (newDrawer && currentDrawer) {
             // console.log('Swapping Drawer innerHTML content right now...');
              currentDrawer.innerHTML = newDrawer.innerHTML;
              currentDrawer.className = newDrawer.className;
            //  console.log('Updated DOM Drawer content is now:', currentDrawer.innerHTML);
            } else {
             // console.warn("AJAX loaded HTML successfully, but couldn't match the drawer elements in the DOM to swap them.");
            }

            const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('.cart-drawer') || document.querySelector('#CartDrawer');
           
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              const empty = document.querySelector('.drawer__inner-empty') || document.querySelector('.cart-drawer__empty');
              if (empty) empty.style.display = 'none';

              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
                initRecommendationSlider();
              } else {
                cartDrawer.classList.add('active', 'animate');
                document.body.classList.add('overflow-hidden');
              }
            }
            
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function(){
             updateCartCount();
            },500);
            if (window.theme && window.theme.CartDrawer) window.theme.CartDrawer.open();
          });
      })
      .catch(err => {
        console.error('AJAX Add to Cart Error Detail:', err);
      })
      .finally(() => {
        const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
        textSpans.forEach(span => span.style.removeProperty('visibility'));
        const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
        if (pdpSpinner) pdpSpinner.classList.add('hidden');
      });
    }
  }, true);
} else {
  document.addEventListener('click', function (e) {
    const pdpBtn = e.target.closest('.product-form__submit');
    if (pdpBtn && pdpBtn.closest('.product-form__buttons')) {
      if (pdpBtn.hasAttribute('disabled')) return;
      const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
      textSpans.forEach(span => span.style.setProperty('visibility', 'hidden', 'important'));
      const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
      if (pdpSpinner) pdpSpinner.classList.remove('hidden');
    }
  }, true);
}


// document.addEventListener('click', function (e) {
//   if (!window.location.pathname.includes('/cart')) return;

//   const cartIcon = e.target.closest('#cart-icon-bubble, a[href*="/cart"], .header__icon--cart');

//   if (cartIcon) {
//     e.preventDefault();
//     window.location.reload();
//   }
// });
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const STORAGE_KEY = "jdgm_badge_map_v5";

  function loadStoredMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function saveMap(map) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) {}
  }

  let cachedBadgeMap = loadStoredMap();

  function getStarsFromBadge(prevBadge) {
    if (!prevBadge) return '';
    return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
      if (star.classList.contains("jdgm--on")) return '<span style="color:#FFCA52;font-size:15px;">★</span>';
      if (star.classList.contains("jdgm--half")) return '<span style="color:#FFCA52;font-size:15px;">★</span>';
      return '<span style="color:#ddd;font-size:15px;">★</span>';
    }).join("");
  }

  function findTitleNearBadge(badge) {
    let el = badge?.parentElement, depth = 0;
    while (el && depth < 8) {
      const t = el.querySelector("h1,h2,h3,h4,.product-title,.card__heading,[class*='title']:not([class*='badge']):not([class*='review'])");
      if (t?.textContent?.trim()) return t.textContent.trim();
      const d = el.getAttribute("data-product-title") || el.getAttribute("data-title") || el.getAttribute("data-name");
      if (d) return d;
      el = el.parentElement; depth++;
    }
    return null;
  }

  function normalize(str) { return (str || "").toLowerCase().replace(/\s+/g, " ").trim(); }

  function buildTitleBadgeMap() {
    const map = loadStoredMap();
    document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
      if (!badge) return;
      const prevBadge = badge.querySelector(".jdgm-prev-badge");
      if (!prevBadge) return;
      const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
      const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;
      const jdgmTitle = prevBadge.getAttribute("data-product-title") || badge.getAttribute("data-product-title");
      const title = jdgmTitle || findTitleNearBadge(badge);
      if (!title) return;
      const key = normalize(title);
      if (count === 0 || rating === 0) { delete map[key]; return; }
      const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
      if (!badgeText || badgeText.toLowerCase().includes("no review")) { delete map[key]; return; }
      map[key] = { stars: getStarsFromBadge(prevBadge), text: badgeText, rating, count };
    });
    cachedBadgeMap = map;
    saveMap(map);
    return map;
  }

  // --- NEW NATIVE CART DRAWER INJECTION LOGIC ---
  function injectNativeCartBadges() {
    const drawerTarget = document.querySelector('cart-drawer') || document.querySelector('#CartDrawer') || document.body;
    const cartItems = drawerTarget.querySelectorAll('.cart-item');
    if (!cartItems.length) return;

    const badgeMap = Object.keys(cachedBadgeMap).length > 0 ? cachedBadgeMap : buildTitleBadgeMap();
    if (!Object.keys(badgeMap).length) return;

    cartItems.forEach(function (item) {
      if (!item) return;

      // Shopify Native Cart Drawer ke specific class targets
      const detailsContainer = item.querySelector('.cart-item__details');
      const nameElement = item.querySelector('.cart-item__name');
      if (!detailsContainer || !nameElement) return;

      // Dobara inject na ho iske liye safety check
      if (detailsContainer.querySelector(".custom-native-jdgm-review")) return;

      const titleText = nameElement.textContent || "";
      const data = badgeMap[normalize(titleText)];
      if (!data) return;

      const reviewWrapper = document.createElement("div");
      reviewWrapper.className = "custom-native-jdgm-review";
      reviewWrapper.style.cssText = "margin-top: 2px; margin-bottom: 6px; display: block !important;";
      reviewWrapper.innerHTML = `
          <div class="custom-jdgm-review-flex" style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
              <span class="cstm-item-stars" style="display: inline-flex !important; gap: 3px; vertical-align: middle;">${data.stars}</span>
              <span class="review-icon" style="display: inline-flex; align-items: center;">
                 <svg width="14" height="13" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
                 </svg>
              </span>
              <span class="cstm-pdp-reviw-txt" style="font-size: 12px; color: #3D3D3D;">${data.text}</span>
          </div>`;

      // Title ke theek niche inject kar diya native structure mein
      nameElement.insertAdjacentElement("afterend", reviewWrapper);
    });
  }

  // --- DEBOUNCE FUNCTION BOILERPLATE ---
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // --- EVENTS & MUTATION LISTENERS ---
  window.addEventListener("load", function () {
    if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();

    if (document.body) {
      // Main Page handler aur Native Cart change observer dono targets listen karega
      const globalObserver = new MutationObserver(debounce(function () {
        if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
        injectNativeCartBadges(); // Har DOM change aur update par native check chalega
      }, 200));
      
      globalObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Intercept click on generic cart components as immediate action backup
    document.addEventListener("click", function (e) {
      if (e && e.target && e.target.closest("[class*='cart'],[id*='cart'],[href*='cart']")) {
        setTimeout(injectNativeCartBadges, 300);
      }
    }, true);
    
    // Initial run backup
    setTimeout(injectNativeCartBadges, 500);
  });
})();

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const STORAGE_KEY = "jdgm_badge_map_v5";

  function loadStoredMap() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function saveMap(map) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch (e) {}
  }

  let cachedBadgeMap = loadStoredMap();

  function getStarsFromBadge(prevBadge) {
    if (!prevBadge) return '';
    return Array.from(prevBadge.querySelectorAll(".jdgm-star")).map(star => {
      if (star.classList.contains("jdgm--on")) return '<span style="color:#FFCA52;font-size:14px;">★</span>';
      if (star.classList.contains("jdgm--half")) return '<span style="color:#FFCA52;font-size:14px;">★</span>';
      return '<span style="color:#ddd;font-size:14px;">★</span>';
    }).join("");
  }

  function findTitleNearBadge(badge) {
    let el = badge?.parentElement, depth = 0;
    while (el && depth < 8) {
      const t = el.querySelector("h1,h2,h3,h4,.product-title,.card__heading,[class*='title']:not([class*='badge']):not([class*='review'])");
      if (t?.textContent?.trim()) return t.textContent.trim();
      const d = el.getAttribute("data-product-title") || el.getAttribute("data-title") || el.getAttribute("data-name");
      if (d) return d;
      el = el.parentElement; depth++;
    }
    return null;
  }

  function normalize(str) { return (str || "").toLowerCase().replace(/\s+/g, " ").trim(); }

  function buildTitleBadgeMap() {
    const map = loadStoredMap();
    document.querySelectorAll(".jdgm-preview-badge").forEach(function (badge) {
      if (!badge) return;
      const prevBadge = badge.querySelector(".jdgm-prev-badge");
      if (!prevBadge) return;
      const count = parseInt(prevBadge.getAttribute("data-number-of-reviews")) || 0;
      const rating = parseFloat(prevBadge.getAttribute("data-average-rating")) || 0;
      const jdgmTitle = prevBadge.getAttribute("data-product-title") || badge.getAttribute("data-product-title");
      const title = jdgmTitle || findTitleNearBadge(badge);
      if (!title) return;
      const key = normalize(title);
      if (count === 0 || rating === 0) { delete map[key]; return; }
      const badgeText = prevBadge.querySelector(".jdgm-prev-badge__text")?.textContent?.trim();
      if (!badgeText || badgeText.toLowerCase().includes("no review")) { delete map[key]; return; }
      map[key] = { stars: getStarsFromBadge(prevBadge), text: badgeText, rating, count };
    });
    cachedBadgeMap = map;
    saveMap(map);
    return map;
  }

  // --- FIXED FOR YOUR SPECIFIC TABLE HTML ---
  function injectNativeCartBadges() {
    // Pure page ya cart drawer mein jitne bhi tr.cart-item hain unhe select karega
    const cartRows = document.querySelectorAll('tr.cart-item');
    if (!cartRows.length) return;

    const badgeMap = Object.keys(cachedBadgeMap).length > 0 ? cachedBadgeMap : buildTitleBadgeMap();
    if (!Object.keys(badgeMap).length) return;

    cartRows.forEach(function (row) {
      if (!row) return;

      // Aapke HTML ke structural selectors
      const detailsCell = row.querySelector('.cart-item__details');
      const nameAnchor = row.querySelector('.cart-item__name');
      if (!detailsCell || !nameAnchor) return;

      // Duplicate injection check
      if (detailsCell.querySelector(".custom-native-jdgm-review")) return;

      const titleText = nameAnchor.textContent || "";
      const data = badgeMap[normalize(titleText)];
      if (!data) return;

      const reviewWrapper = document.createElement("div");
      reviewWrapper.className = "custom-native-jdgm-review";
      reviewWrapper.style.cssText = "margin-top: 4px; margin-bottom: 6px; display: block !important; width: 100%; text-align: left;";
      reviewWrapper.innerHTML = `
          <div class="custom-jdgm-review-flex" style="display: inline-flex; align-items: center; gap: 5px; flex-wrap: wrap;">
              <span class="cstm-item-stars" style="display: inline-flex !important; gap: 1px; vertical-align: middle;">${data.stars}</span>
              <span class="review-icon" style="display: inline-flex; align-items: center; transform: translateY(1px);">
                 <svg width="12" height="12" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M13.7635 7.39269C14.0932 7.01572 14.0932 6.45303 13.7635 6.07606L12.995 5.19728C12.8147 4.9911 12.7268 4.71997 12.752 4.44721L12.8589 3.28715C12.9049 2.78765 12.5737 2.33134 12.0846 2.22023L10.9529 1.96318C10.6846 1.90224 10.4533 1.73346 10.3134 1.49657L9.71994 0.491771C9.46416 0.0586931 8.92651 -0.117005 8.46434 0.0814546L7.40051 0.538275C7.14859 0.646454 6.86329 0.646454 6.61137 0.538275L5.54642 0.0809748C5.08474 -0.117279 4.54763 0.0578342 4.29152 0.490112L3.69937 1.48956C3.55891 1.72664 3.32684 1.89524 3.05797 1.95557L1.92987 2.20869C1.43954 2.31871 1.10702 2.77552 1.153 3.27594L1.26013 4.44173C1.28513 4.71379 1.19773 4.98424 1.01823 5.19021L0.246142 6.07622C-0.0824211 6.45326 -0.0819232 7.01506 0.247308 7.39151L1.01697 8.27158C1.19724 8.4777 1.28509 8.74872 1.26003 9.0214L1.15279 10.1885C1.1069 10.6879 1.43803 11.144 1.92709 11.2551L3.05974 11.5124C3.32756 11.5732 3.55858 11.7416 3.69857 11.9778L4.2904 12.9767C4.54699 13.4098 5.08552 13.5847 5.54758 13.3849L6.61044 12.9254C6.86289 12.8162 7.14915 12.8159 7.40186 12.9244L8.46546 13.3811C8.92714 13.5794 9.46425 13.4042 9.72036 12.972L10.3133 11.9712C10.4533 11.7349 10.6843 11.5666 10.9521 11.5057L12.0846 11.2485C12.5737 11.1374 12.9049 10.6811 12.8589 10.1816L12.752 9.02154C12.7268 8.74878 12.8147 8.47766 12.995 8.27147L13.7635 7.39269ZM6.44064 9.17107C6.04991 9.56287 5.41529 9.56289 5.02454 9.17111L3.69111 7.83417C3.41937 7.56172 3.41966 7.12066 3.69175 6.84856C3.96451 6.5758 4.40689 6.57628 4.67906 6.84963L5.0243 7.19634C5.41504 7.58878 6.05031 7.58892 6.44123 7.19666L9.13936 4.48931C9.41164 4.2161 9.85396 4.21572 10.1267 4.48847C10.3988 4.76062 10.3991 5.20177 10.1274 5.47429L6.44064 9.17107Z" fill="#4C6FFE"/>
                 </svg>
              </span>
              <span class="cstm-pdp-reviw-txt" style="font-size: 11px; color: #3D3D3D; font-family: inherit;">${data.text}</span>
          </div>`;

      // Title anchor link ke theek baad cell ke andar inject karega (price data se pehle)
      nameAnchor.insertAdjacentElement("afterend", reviewWrapper);
    });
  }

  // --- DEBOUNCE BOILERPLATE ---
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // --- RUNNERS AND OBSERVERS ---
  window.addEventListener("load", function () {
    if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();

    if (document.body) {
      const globalObserver = new MutationObserver(debounce(function () {
        if (document.querySelector(".jdgm-preview-badge")) buildTitleBadgeMap();
        injectNativeCartBadges();
      }, 250));
      
      globalObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Ajax updates aur quick cart views handle karne ke liye triggers
    document.addEventListener("click", function (e) {
      if (e?.target?.closest("[class*='cart'],[id*='cart'],[name='plus'],[name='minus'],.cart-item__media")) {
        setTimeout(injectNativeCartBadges, 400);
      }
    }, true);
    
    setTimeout(injectNativeCartBadges, 600);
  });
})();
// July 15
// if (window.enableGokwikDrawer === false) {
// document.addEventListener('click', function (e) {
//     const pdpBtn = e.target.closest('.product-form__submit');

//     if (pdpBtn && pdpBtn.closest('.product-form__buttons')) {
//         if (pdpBtn.hasAttribute('disabled')) return;
//         e.preventDefault();

//         const form = pdpBtn.closest('form');
//         if (!form) return;

//         // Current variant id explicitly nikal ke confirm karo
//         const variantInput = form.querySelector('input[name="id"], .product-variant-id');
//         const currentVariantId = variantInput ? variantInput.value : null;

//         console.log('Sending variant id:', currentVariantId); // Debug ke liye

//         if (!currentVariantId) {
//             console.error('Variant ID nahi mila!');
//             return;
//         }

//         const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
//         textSpans.forEach(span => span.style.setProperty('visibility', 'hidden', 'important'));

//         const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
//         if (pdpSpinner) pdpSpinner.classList.remove('hidden');

//         const formData = new FormData(form);
//         // Safety: variant id ko explicitly overwrite kar do
//         formData.set('id', currentVariantId);

//         fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Accept': 'application/json' },
//             body: formData
//         })
//         .then(res => {
//             if (!res.ok) return res.json().then(err => { throw new Error(err.description || 'Failed'); });
//             return res.json();
//         })
//         .then(data => {
//             console.log('Added:', data);
//             return fetch(`${window.location.pathname}?sections=cart-drawer`);
//         })
//         .then(res => res.json())
//         .then(sectionData => {
//             const newDrawerHTML = sectionData['cart-drawer'];
//             if (newDrawerHTML) {
//                 const parser = new DOMParser();
//                 const doc = parser.parseFromString(newDrawerHTML, 'text/html');
//                 const newInner = doc.querySelector('cart-drawer');
//                 const currentDrawer = document.querySelector('cart-drawer');
//                 if (newInner && currentDrawer) currentDrawer.innerHTML = newInner.innerHTML;
//             }
//             const cartDrawer = document.querySelector('cart-drawer');
//             if (cartDrawer) {
//                 if (typeof cartDrawer.open === 'function') cartDrawer.open();
//                 else {
//                     cartDrawer.classList.add('active', 'animate');
//                     document.body.classList.add('overflow-hidden');
//                 }
//             }
//             document.dispatchEvent(new CustomEvent('cart:refresh'));
//         })
//         .catch(err => console.error('Error:', err))
//         .finally(() => {
//             textSpans.forEach(span => span.style.removeProperty('visibility'));
//             if (pdpSpinner) pdpSpinner.classList.add('hidden');
//         });
//     }
// }, true);
// }
// else{
// document.addEventListener('click', function(e) {
//     // Target checking: product form ke andar ka submit button
//     const pdpBtn = e.target.closest('.product-form__submit');
    
//     if (pdpBtn && pdpBtn.closest('.product-form__buttons')) {
//         // Agar button pehle se disabled hai toh click bypass karein
//         if (pdpBtn.hasAttribute('disabled')) return;

//         // Dono text spans ko hide karne ke liye dynamic styling apply karein
//         const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
//         textSpans.forEach(span => {
//             span.style.setProperty('visibility', 'hidden', 'important');

//         });

//         // Spinner se 'hidden' class remove karke use active karein
//         const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
//         if (pdpSpinner) {
//             pdpSpinner.classList.remove('hidden');
//         }
//     }
// }, true);
// }
// July 15

// 2. Apka Existing MutationObserver (Updated with PDP Reset Support)
// const observer = new MutationObserver(() => {
//     // shadow host tracking
//     const host = document.querySelector("shadow-dom-container"); 
//     if (!host?.shadowRoot) return;
//     const cart = host.shadowRoot.querySelector(".sidecart.svelte-uimbe4");

//     if (cart) {
//         // --- Pehle se chal raha logic dusre pages ke liye ---
//         $(".card-add-to-cart #submit_button").each(function(){
//             $(this).removeClass('visibility-hidden');
//             $(this).parents(".card-add-to-cart").find('.loading__spinner').addClass("hidden");
//         });

//         // --- NAYA LOGIC: PDP Page Reset ---
//         // Jaise hi sidecart open ho jaye, PDP loader ko wapas hide aur text ko normal karein
//         const pdpBtn = document.querySelector('.product-form__submit');
//         if (pdpBtn) {
//             const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
//             if (pdpSpinner) {
//                 pdpSpinner.classList.add('hidden');
//             }
//             const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
//             textSpans.forEach(span => {
//                 span.style.removeProperty('visibility');
//             });
//         }
//     }
// });

// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });



// Ms Clarity app ( dublicate obserever call )

// // 2. PDP Add to Cart Reset Observer
(function() {
    const pdpResetObserver = new MutationObserver(() => {
        // shadow host tracking
        const host = document.querySelector("shadow-dom-container"); 
        if (!host?.shadowRoot) return;
        const cart = host.shadowRoot.querySelector(".sidecart.svelte-uimbe4");

        if (cart) {
            // --- Pehle se chal raha logic dusre pages ke liye ---
            $(".card-add-to-cart #submit_button").each(function(){
                $(this).removeClass('visibility-hidden');
                $(this).parents(".card-add-to-cart").find('.loading__spinner').addClass("hidden");
            });

            // --- NAYA LOGIC: PDP Page Reset ---
            const pdpBtn = document.querySelector('.product-form__submit');
            if (pdpBtn) {
                const pdpSpinner = pdpBtn.querySelector('.loading__spinner');
                if (pdpSpinner) {
                    pdpSpinner.classList.add('hidden');
                }
                const textSpans = pdpBtn.querySelectorAll('.submit_button_cstm, .submit_button_cstm_freq');
                textSpans.forEach(span => {
                    span.style.removeProperty('visibility');
                });
            }
        }
    });

    pdpResetObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
})();


document.addEventListener('click',function(e){

  const button = e.target.closest('.price-details-toggle');

  if(!button) return;

  const box = document.querySelector('.price-details-box');

  if(box){
    box.classList.toggle('active');
    button.classList.toggle('active');
  }

});
// const observer = new MutationObserver(() => {
//     // shadow host
//     const host = document.querySelector("shadow-dom-container"); 
//     // actual host selector yahan daalo
//     if (!host?.shadowRoot) return;
//     const cart = host.shadowRoot.querySelector(".sidecart.svelte-uimbe4");

//     if (cart) {
     
//         $(".card-add-to-cart #submit_button").each(function(){
//           $(this).removeClass('visibility-hidden');
//           $(this).parents(".card-add-to-cart").find('.loading__spinner').addClass("hidden");
//       });
//     }
// });

// observer.observe(document.body, {
//     childList: true,
//     subtree: true
// });






//clarity app
// if (!window.cartObserver) {
//   window.cartObserver = new MutationObserver(() => {

//     const host = document.querySelector("shadow-dom-container");

//     if (!host?.shadowRoot) return;

//     const cart = host.shadowRoot.querySelector(".sidecart.svelte-uimbe4");

//     if (cart) {
//       $(".card-add-to-cart #submit_button").each(function () {
//         $(this).removeClass("visibility-hidden");
//         $(this)
//           .parents(".card-add-to-cart")
//           .find(".loading__spinner")
//           .addClass("hidden");
//       });
//     }
//   });

//   window.cartObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// }


// function restructureGoKwikCart() {
//   document.querySelectorAll('.item.svelte-qc3127').forEach((item) => {
//     if (item.classList.contains('gk-restructured')) return;
//     const variantSelector = item.querySelector('.variant-selector');
//     const quantityHandler = item.querySelector('.quantity-handler');
//     const details = item.querySelector('.details');
//     const quantityWrapper = item.querySelector('.quantity-handler-wrapper');
//     const finalPrice = item.querySelector('.final-price');
//     const comparePrice = item.querySelector('.compare-at-price');
//     const discount = item.querySelector('.discount-percentage');
//     if (!variantSelector || !details) return;
//     let priceRow = document.createElement('div');
//     priceRow.className = 'custom-price-row';
//     if (finalPrice) priceRow.appendChild(finalPrice);
//     if (comparePrice) priceRow.appendChild(comparePrice);
//     if (discount) priceRow.appendChild(discount);
//     variantSelector.prepend(priceRow);
//     if (quantityHandler) {
//       details.appendChild(quantityHandler);
//     }
//     if (quantityWrapper) {
//       const removeBtn = quantityWrapper.querySelector('.remove-btn');
//       quantityWrapper.innerHTML = '';
//       if (removeBtn) {
//         quantityWrapper.appendChild(removeBtn);
//       }
//     }
//     item.classList.add('gk-restructured');
//   });
// }
// setTimeout(restructureGoKwikCart, 500);
// setTimeout(restructureGoKwikCart, 1200);
// setTimeout(restructureGoKwikCart, 2000);

(function () {
  'use strict';
  function updateCartBubbles() {
  fetch('/cart.js', {
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }

      return response.json();
    })
    .then(function (cart) {
      document
        .querySelectorAll('.cart-count-bubble')
        .forEach(function (cartBubble) {

          var count = cartBubble.querySelector('span');

          if (count) {
            count.textContent = cart.item_count;
          } else {
            cartBubble.textContent = cart.item_count;
          }

          cartBubble.classList.toggle(
            'hide',
            cart.item_count === 0
          );
        });
    })
    .catch(function (error) {
      console.error(
        '[Cart Bubble] Update error:',
        error
      );
    });
}

  function isCartRequest(url) {
    if (!url) return false;

    return (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    );
  }
  var originalFetch = window.fetch;

  window.fetch = function () {
    var args = arguments;

    return originalFetch.apply(this, args).then(function (response) {

      var url = '';

      if (args[0] instanceof Request) {
        url = args[0].url;
      } else {
        url = args[0];
      }

      if (isCartRequest(url)) {
        setTimeout(function () {
          updateCartBubbles();
        }, 300);
      }

      return response;
    });
  };
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._cartRequestUrl = url;

    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var xhr = this;

    xhr.addEventListener('load', function () {

      if (isCartRequest(xhr._cartRequestUrl)) {
        setTimeout(function () {
          updateCartBubbles();
        }, 300);
      }

    });

    return originalSend.apply(this, arguments);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartBubbles);
  } else {
    updateCartBubbles();
  }

})();

document.addEventListener('DOMContentLoaded', function () {
  const stickyCartBar = document.querySelector('#cstm-addtocart-sticky');
  if (!stickyCartBar) return;
 
  // ---- Point 1: sticky bar is ALWAYS visible now (no scroll show/hide) ----
  stickyCartBar.classList.add('display_flex');
  stickyCartBar.classList.remove('display_none');
  const variantInput = document.querySelector('product-form.product-form input.product-variant-id');
 
  // ---- Dropdown-style ul/li variant selector elements ----
  const stickyDropdownToggle = stickyCartBar.querySelector('.sticky-dropdown-toggle');
  const stickyDropdownLabel = stickyCartBar.querySelector('.selected-label');
  const stickyVariantList = stickyCartBar.querySelector('.sticky-variant-list');
  const stickyVariantItems = stickyVariantList
    ? Array.from(stickyVariantList.querySelectorAll('.sticky-variant-item'))
    : [];
 
  const imgEl = stickyCartBar.querySelector('.image_featured_image img');
  const priceEl = stickyCartBar.querySelector('.price');
  const comparePriceEl = stickyCartBar.querySelector('.compare-price');
  const saveTextEl = stickyCartBar.querySelector('.save_text');
  const addToCartBtn = stickyCartBar.querySelector('#add-to-cart-btn');
  const btnTextEl = addToCartBtn ? addToCartBtn.querySelector('.btn-text') : null;
 
  if (btnTextEl) {
    addToCartBtn.dataset.addLabel = btnTextEl.textContent.trim();
  }
 
  const formatMoney = (amount) => '₹' + (amount / 100).toFixed(2);
 
  // ---- Point 2: paint image/price/compare-price/save-text for a given variant ----
  function renderVariantDisplay(opts) {
    if (priceEl) priceEl.textContent = formatMoney(opts.price);
 
    const compareNum = parseFloat(opts.comparePrice || 0);
    if (comparePriceEl) {
      if (compareNum > opts.price) {
        comparePriceEl.textContent = formatMoney(compareNum);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.style.display = 'none';
      }
    }
 
    if (saveTextEl) {
      const save = compareNum - opts.price;
      if (save > 0) {
        saveTextEl.textContent = `You'll save ${formatMoney(save)}`;
        saveTextEl.style.display = '';
      } else {
        saveTextEl.textContent = '';
        saveTextEl.style.display = 'none';
      }
    }
 
    if (imgEl && opts.image) {
      imgEl.src = opts.image;
    }
  }
 
  function updateAvailability(available) {
    if (!addToCartBtn) return;
    if (!available) {
      addToCartBtn.setAttribute('disabled', 'disabled');
    } else if (addToCartBtn.dataset.cartState !== 'view') {
      addToCartBtn.removeAttribute('disabled');
    }
  }

/* cart count badges */
  const cartCountBadge = stickyCartBar.querySelector('.cart-count-badge');

  function refreshButtonStateForVariant(variantId) {
    if (!addToCartBtn || !btnTextEl || !variantId) return;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const line = cart.items.find((item) => String(item.variant_id) === String(variantId));
        if (line && line.quantity > 0) {
          addToCartBtn.dataset.cartState = 'view';
          btnTextEl.textContent = 'View Cart';
          if (cartCountBadge) {
            cartCountBadge.textContent = cart.item_count;
            cartCountBadge.style.display = 'flex';
          }
          addToCartBtn.removeAttribute('disabled');
        } else {
          addToCartBtn.dataset.cartState = 'add';
          btnTextEl.textContent = addToCartBtn.dataset.addLabel || 'Add To Cart';
          if (cartCountBadge) cartCountBadge.style.display = 'none';
        }
      })
      .catch((err) => console.error('Cart state check error:', err));
  }

  // expose for the ajax add-to-cart success handler below
  window.stickyRefreshButtonState = refreshButtonStateForVariant;
 
  // ---- li-based dropdown variant selector (replaces the old <select>) ----
  function renderFromListItem(itemEl) {
    if (!itemEl) return;
    renderVariantDisplay({
      price: parseFloat(itemEl.dataset.price),
      comparePrice: parseFloat(itemEl.dataset.comparePrice),
      image: itemEl.dataset.image
    });
    updateAvailability(itemEl.dataset.available === 'true');
    refreshButtonStateForVariant(itemEl.dataset.variantId);
  }
 
  function getSelectedStickyItem() {
    return stickyVariantList
      ? stickyVariantList.querySelector('.sticky-variant-item.selected')
      : null;
  }
 
  function closeStickyDropdown() {
    if (stickyVariantList) {
      stickyVariantList.classList.remove('open');
    }
    if (stickyDropdownToggle) {
      stickyDropdownToggle.classList.remove('open');
    }
  }
 
  function selectVariantItem(itemEl, opts) {
    if (!itemEl) return;
    stickyVariantItems.forEach((li) => li.classList.remove('selected'));
    itemEl.classList.add('selected');
    renderFromListItem(itemEl);
 
    // update the dropdown toggle button's visible label
    if (stickyDropdownLabel) {
      stickyDropdownLabel.textContent = itemEl.textContent.trim();
    }
 
    // close the dropdown after a pick (not needed when syncing from main variant picker)
    if (!(opts && opts.fromMainSync)) {
      closeStickyDropdown();
    }
 
    // keep the real Shopify variant input in sync so the native product form
    // (and anything else on the page reading it) matches the sticky bar
    if (variantInput && !(opts && opts.fromMainSync)) {
      variantInput.value = itemEl.dataset.variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
 
  // ---- Point 3: sticky dropdown drives its own display + which variant gets added ----
  if (stickyVariantItems.length) {
    stickyVariantItems.forEach((itemEl) => {
      if (itemEl.dataset.available === 'false') return; // don't wire up sold-out items
      itemEl.addEventListener('click', function (e) {
        e.stopPropagation();
        selectVariantItem(itemEl);
      });
    });
    renderFromListItem(getSelectedStickyItem() || stickyVariantItems[0]);
 
    // set initial toggle label from whichever item is selected on load
    if (stickyDropdownLabel) {
      const initialItem = getSelectedStickyItem() || stickyVariantItems[0];
      stickyDropdownLabel.textContent = initialItem.textContent.trim();
    }
  } else if (variantInput) {
    refreshButtonStateForVariant(variantInput.value);
  }
 
  // ---- open/close the dropdown ----
  if (stickyDropdownToggle && stickyVariantList) {
    stickyDropdownToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = stickyVariantList.classList.toggle('open');
      stickyDropdownToggle.classList.toggle('open', isOpen);
    });
 
    // close dropdown when clicking outside it
    document.addEventListener('click', function (e) {
      if (
        !stickyDropdownToggle.contains(e.target) &&
        !stickyVariantList.contains(e.target)
      ) {
        closeStickyDropdown();
      }
    });
 
    // close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeStickyDropdown();
      }
    });
  }
 
  // ---- Point 2: keep sticky bar in sync when the MAIN page variant picker changes ----
  function syncStickyFromMainVariant() {
    if (!variantInput || !stickyVariantItems.length) return;
    const currentId = variantInput.value;
    const matchingItem = stickyVariantItems.find(
      (li) => li.dataset.variantId === currentId
    );
    const currentlySelected = getSelectedStickyItem();
    if (matchingItem && matchingItem !== currentlySelected) {
      selectVariantItem(matchingItem, { fromMainSync: true });
    }
  }
 
  if (variantInput) {
    variantInput.addEventListener('change', syncStickyFromMainVariant);
    new MutationObserver(syncStickyFromMainVariant).observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
    // theme-agnostic safety net for themes that set .value via JS with no event/attribute mutation
    let lastKnownVariant = variantInput.value;
    setInterval(function () {
      if (variantInput.value !== lastKnownVariant) {
        lastKnownVariant = variantInput.value;
        syncStickyFromMainVariant();
      }
    }, 400);
  }
  function currentSelectedVariantId() {
    const selectedItem = getSelectedStickyItem();
    return selectedItem
      ? selectedItem.dataset.variantId
      : (variantInput ? variantInput.value : null);
  }
 
  // 1) lightweight poll — catches changes made anywhere (drawer, native form, other tab)
  setInterval(function () {
    refreshButtonStateForVariant(currentSelectedVariantId());
  }, 2500);
 
  // 2) refresh instantly when the user comes back to this tab/window
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      refreshButtonStateForVariant(currentSelectedVariantId());
    }
  });
  window.addEventListener('focus', function () {
    refreshButtonStateForVariant(currentSelectedVariantId());
  });
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      refreshButtonStateForVariant(currentSelectedVariantId());
    });
  });
  const cartBubbleEl = document.querySelector('.cart-count-bubble');
  if (cartBubbleEl) {
    new MutationObserver(function () {
      refreshButtonStateForVariant(currentSelectedVariantId());
    }).observe(cartBubbleEl, { childList: true, characterData: true, subtree: true });
  }
});
}



